/* global Acima, AcimaClass, acimaiframeUrl, acimaLocationGuid, ApplePaySession, braintree, brainTreeAuthorizationToken, can, ga, google, googleMerchantId, GooglePayClass, isPaypalExpressAvailable, isProduction, paypal, viewModelProperties */

import {
	cashApp,
	configApplePay,
	configGooglePay,
	configPaypal
} from "~/public/utilities/utilities";

/**
 * Variables to identify recently clicked element
 */
var clickedelement;
/**
 * Variables to instantiate Acima
 */
var AcimaInstance;
/**
 * Variables to instantiate Apple pay
 */
var ApplePayClassInstance;
/**
 * Variables to instantiate GooglePay
 */
var GooglePayInstance;
/**
 * Variables to instantiate Paypal
 */
var PaypalClassInstance;
/**
 * Billing address constructor function.
 * @function BillingAddress
 */
var BillingAddress = can.Map.extend({
	define: {
		address_book_address_id: {
			type: "string",
			value: "0"
		},
		Country: {
			serialize: false
		},
		same_info: {
			value: "1",
			set: function(newValue) {
				if ('0' === newValue && '1' === this.same_info) {
					this.attr('first_name', '');
					this.attr('last_name', '');
					this.attr('company', '');
					this.attr('address_1', '');
					this.attr('address_2', '');
					this.attr('city', '');
					this.attr('state', '');
					this.attr('zip', '');
					this.attr('country', 'US');
					this.attr('phone', '');
				} else if ('1' === newValue && '0' === this.same_info) {
					let ShippingAddress = $('checkout-main').viewModel().attr('ShippingAddress');

					this.attr('first_name', ShippingAddress.attr('first_name'));
					this.attr('last_name', ShippingAddress.attr('last_name'));
					this.attr('company', ShippingAddress.attr('company'));
					this.attr('address_1', ShippingAddress.attr('address_1'));
					this.attr('address_2', ShippingAddress.attr('address_2'));
					this.attr('city', ShippingAddress.attr('city'));
					this.attr('state', ShippingAddress.attr('state'));
					this.attr('zip', ShippingAddress.attr('zip'));
					this.attr('country', ShippingAddress.attr('country'));
					this.attr('phone', ShippingAddress.attr('phone'));
				}

				return newValue;
			}
		}
	}
});

/**
 * Constructor function for extra can.Map for temporary data.
 * @function CheckoutForm
 */
var CheckoutForm = can.Map.extend({
	define: {
		csc: {
			type: "string",
			value: ""
		},
		labels: {
			Type: can.Map,
			serialize: false
		},
		maxSonicbux: {
			type: "string",
			value: "0.00",
			serialize: false,
			set: function(newValue) {
				return formatMoney(newValue);
			}
		},
		maxStoreCredit: {
			type: "string",
			value: "0.00",
			serialize: false,
			set: function(newValue) {
				return formatMoney(newValue);
			}
		},
		shippingProtectionAvailable: {
			type: "boolean",
			value: "1"
		},
		shippingProtectionFee: {
			type: "string",
			value: "",
			serialize: false,
			set: function(newValue) {
				if (null === newValue) {
					newValue = '';
				}

				return formatMoney(newValue);
			}
		},
		shippingProtectionSelected: {
			type: "boolean",
			value: "1"
		},
		useSonicbux: {
			type: "string",
			value: "0"
		},
		useSonicbuxAmount: {
			type: "string",
			value: "0.00",
			set: function(newValue) {
				return this.conformCreditAmount(newValue, this.attr('maxSonicbux'));
			}
		},
		useStoreCredit: {
			type: "string",
			value: "0"
		},
		useStoreCreditAmount: {
			type: "string",
			value: "0.00",
			set: function(newValue) {
				return this.conformCreditAmount(newValue, this.attr('maxStoreCredit'));
			}
		}
	},
	/**
	 * Ensures the new value is a dollar amount between 0.00 and the max amount.
	 * @param {Number} newValue
	 * @param {Number} maxAmount
	 * @returns {Number}
	 */
	conformCreditAmount: function(newValue, maxAmount) {
		let fixedNewValue = newValue * 1;

		maxAmount = maxAmount * 1;

		if (fixedNewValue >= 0.01) {
			if (fixedNewValue > maxAmount) {
				fixedNewValue = maxAmount;
			}
		} else {
			fixedNewValue = 0;
		}

		return fixedNewValue.toFixed(2);
	}
});

/**
 * Customer constructor function.
 * @function Customer
 */
var Customer = can.Map.extend({
	define: {
		checkoutRegister: {
			type: "string",
			value: "0"
		},
		is_guest_customer: {
			type: "string",
			value: "1"
		},
		newPassword: {
			type: "string",
			value: ""
		},
		password: {
			type: "string",
			value: ""
		},
		confirmPassword: {
			type: "string",
			value: ""
		},
		otp: {
			type: "string",
			value: ""
		}
	}
});

/**
 * Converts the shipping fee to a string format for proper display.
 * @param {Number|String} newValue
 * @returns {String}
 */
var formatMoney = function(newValue) {
	newValue = newValue * 1;

	if (0 === newValue) {
		newValue = '0.00';
	} else {
		newValue = newValue.toFixed(2);
	}

	return newValue;
};

/**
 * Order constructor function.
 * @function Order
 */
var Order = can.Map.extend({
	define: {
		cardholder_name: {
			type: "string",
			value: "",
			set: function(newValue) {
				if (null === newValue) {
					newValue = '';
				}

				return newValue;
			}
		},
		card_expiration_month: {
			type: "string",
			value: "",
			set: function(newValue) {
				if (null === newValue) {
					newValue = '';
				}

				return newValue;
			}
		},
		card_expiration_year: {
			type: "string",
			value: "",
			set: function(newValue) {
				if (null === newValue) {
					newValue = '';
				}

				return newValue;
			}
		},
		cardIdentifier: {
			type: "string",
			value: "",
			set: function(newValue) {
				if (null === newValue) {
					newValue = '';
				}

				return newValue;
			}
		},
		includeGiftMessage: {
			type: "string"
		},
		includeOrderComment: {
			type: "string"
		},
		payment_method: {
			type: "string"
		},
		shipping_fee: {
			type: "string",
			set: function(newValue) {
				return formatMoney(newValue);
			}
		},
		shipping_method: {
			type: "string"
		}
	}
});

/**
 * Constructor function for a can.Map containing the permissions achieved in the
 * checkout flow.
 * @function ProgressClass
 */
var ProgressClass = can.Map.extend({
	define: {
		canEditShippingAddress: {
			type: "boolean",
			value: false,
			serialize: false
		},
		canResetPassword: {
			type: "boolean",
			value: false,
			serialize: false
		},
		canEditAvailableCredit: {
			type: "boolean",
			value: false,
			serialize: false
		},
		canEditShippingMethod: {
			type: "boolean",
			value: false,
			serialize: false
		},
		checkoutProcess: {
			type: "integer",
			value: 10,
			serialize: false
		},
		paymentOption: {
			type: "string",
			/**
			 * Changes the order's payment method selected when the route changes.
			 * @param {String} newValue
			 * @returns {String}
			 */
			set: function(newValue) {
				if (newValue) {
					// Change the payment method selected.
					let paymentMethod = can.hyphenate(newValue).replace('-', '_');

					can.viewModel('checkout-main', 'Order.payment_method_selected', paymentMethod);
				}

				// Must return value to set as we have a `newValue` argument.
				return newValue;
			}
		},
		section: {
			type: "string",
			/**
			 * Clears the paymentOption route property when the section is not
			 * "paymentMethod".
			 * @param {String} newValue
			 * @returns {String}
			 */
			set: function(newValue) {
				// Check if we are changing.
				if ('paymentMethod' === newValue) {
					this.attr('paymentOption', can.camelize(can.viewModel('checkout-main', 'Order.payment_method_selected').replace('_', '-')));
				} else {
					this.removeAttr('paymentOption');
				}

				// Must return value to set as we have a `newValue` argument.
				return newValue;
			}
		}
	},
	/**
	 * Initializes the instance by binding change events for the section and
	 * paymentOption properties.
	 * @returns {undefined}
	 */
	init: function() {
		this.bind('section', function(ev, newValue) {
			let destination;

			if ('undefined' === typeof newValue) {
				destination = 'shippingAddress';
			} else {
				destination = newValue;
			}

			this.goToStep(destination);
		});
		this.bind('paymentOption', function(ev, newValue) {
			if ('undefined' === typeof newValue) {
				if ('paymentMethod' === this.attr('section')) {
					let viewModel = $('checkout-main').viewModel(),
						PaymentMethods = viewModel.attr('PaymentMethods');

					if (PaymentMethods && PaymentMethods.length) {
						viewModel.attr('Order.payment_method_selected', PaymentMethods[0]);
					}
				}
			}

			let expressCheckoutContainer = $('.expressCheckoutContainer');

			if (expressCheckoutContainer.length > 0) {
				expressCheckoutContainer.remove();
				GooglePayInstance = new GooglePayClass();
				if ('undefined' !== typeof isPaypalExpressAvailable && true === isPaypalExpressAvailable) {
					PaypalClassInstance = new PaypalClass();
				}

				if (window.ApplePaySession && ApplePaySession.canMakePayments()) {
					ApplePayClassInstance = new ApplePayClass();
					$('.applepay_method').removeClass('d-none');
				}
			}
		});
	},
	/**
	 * Advances to the selected panel in the checkout flow.
	 * @param {String} step
	 * @returns {Progress} for chaining.
	 */
	goToStep: function(step) {
		let id = '#' + can.hyphenate(step) + '-content';

		// Open the pannel.
		$(id).parent().css('display', 'block')
			// Set previous steps to completed.
			.prevUntil(id).css('display', 'none')
			// Set later steps to incomplete.
			.end().nextAll().css('display', 'none');

		let viewModel = $('checkout-main').viewModel();

		if (viewModel.attr('isGuest')) {
			$('#checkout-contact-info-form #Customer_email').removeAttr('disabled');
		} else {
			$('#checkout-contact-info-form #Customer_email').attr('disabled', true);
		}

		if (step !== 'shippingAddress'
			&& viewModel.ShippingAddress.attr('address_book_address_id') == 0
			&& viewModel.ShippingAddress.attr('previous_address_id') != 0
		) {
			let addressId = viewModel.ShippingAddress.attr('previous_address_id');

			viewModel.ShippingAddress.attr('address_book_address_id', addressId);
			viewModel.updateShippingAddress();
		}

		// if on paymentMethod step, and amount is <= 0 because of credits, redirect customer to credit page.
		// Customer should not be able to select payment method if amount is 0.
		// They need to uncheck credit checkbox to use payment-methods.
		if (step === 'paymentMethod' && viewModel.calculatedTotal() <= 0) {
			let useSonicbux = viewModel.CheckoutForm.attr('useSonicbux'),
				useStoreCredit = viewModel.CheckoutForm.attr('useStoreCredit');

			if (useSonicbux || useStoreCredit) {
				can.route.attr('section', 'availableCredit');
			}
		}

		// Set this and later steps to FALSE.
		switch (id) {
			case '#shipping-address-content':
				this.attr('canEditShippingAddress', false);
				// no break
			case '#reset-password-content':
				this.attr('canResetPassword', false);
				//no break
			case '#shipping-method-content':
				this.attr('canEditShippingMethod', false);
				// no break
			case '#available-credit-content':
				this.attr('canEditAvailableCredit', false);

				break;
		}

		// Set all earlier steps TRUE.
		switch (id) {
			case '#payment-method-content':
				this.attr('canEditAvailableCredit', true);
				// no break
			case '#available-credit-content':
				this.attr('canEditShippingMethod', true);
				// no break
			case '#shipping-method-content':
				this.attr('canEditShippingAddress', true);
				// no break
			case '#reset-password-content':
				this.attr('canResetPassword', true);

				break;
		}

		// Set Progress for each step.
		let checkoutProgress = $('.checkoutProgress'),
			progressPercentage;

		switch (id) {
			case '#shipping-address-content':
				$('.shippingAddressStep').addClass('active').siblings().removeClass('active');
				progressPercentage = parseInt($('.shippingAddressStep').data('progress'));

				break;

			case '#shipping-method-content':
				$('.shippingMethodStep').addClass('active').siblings().removeClass('active');
				progressPercentage = parseInt($('.shippingMethodStep').data('progress'));

				break;

			case '#available-credit-content':
			case '#payment-method-content':
				$('.paymentStep').addClass('active').siblings().removeClass('active');
				progressPercentage = parseInt($('.paymentStep').data('progress'));

				break;
		}
		checkoutProgress.css('width', progressPercentage + '%');

		let selectedVaultCard = $('.selected-vault-card-container .vault-card');

		if ($('.customer-vault-container').length > 0 && selectedVaultCard.find('.card-placeholder').length <= 0) {
			let radio = $("input[name='customer-vault-radio']:checked"),
				cardPlaceholder = radio.closest('.card_radio').find('.card-placeholder').clone(),
				vaultCard = radio.closest('.vault-card');

			selectedVaultCard.html(cardPlaceholder);
			if (vaultCard.hasClass('default')) {
				selectedVaultCard.addClass('default');
				$('.selected-vault-card-container label:last').removeClass('d-none');
				selectedVaultCard.removeClass('p-2').addClass('px-2 pt-4 pb-2');
			} else {
				selectedVaultCard.removeClass('default');
				$('.selected-vault-card-container label:last').addClass('d-none');
				selectedVaultCard.addClass('p-2').removeClass('px-2 pt-4 pb-2');
			}
		}

		// Return the views model for chaining.
		return this;
	}
});

/**
 * Instance of ProgressClass used to track route and page state. Must be one
 * instance so it can be used in viewModel.Progress and in can.route.map.
 * @type ProgressClass
 */
var Progress = new ProgressClass();

/**
 * Constructor function for the shipping address can.Map.
 * @function ShippingAddress
 */
var ShippingAddress = can.Map.extend({
	define: {
		address_book_address_id: {
			type: "string",
			value: "0"
		},
		previous_address_id: {
			type: "string",
			value: "0"
		},
		country: {
			type: "string",
			value: "US",
			/**
			 * Defaults country to "US" if it is an empty string.
			 * @param {String} newValue
			 * @returns {String}
			 */
			set: function(newValue) {
				if ('' === newValue) {
					newValue = 'US';
				}

				return newValue;
			}
		},
		Country: {
			serialize: false
		},
		state: {
			type: "string",
			value: "",
			/**
			 * Defaults state to an empty string if it is NULL.
			 * @param {mixed} newValue
			 * @returns {String}
			 */
			set: function(newValue) {
				if (null === newValue) {
					newValue = '';
				}

				return newValue;
			}
		}
	}
});

/**
 * Constructor function for the vault address can.Map.
 * @function VaultAddress
 */
var VaultAddress = can.Map.extend({
	define: {
		country: {
			type: "string",
			value: "US",
			/**
			 * Defaults country to "US" if it is an empty string.
			 * @param {String} newValue
			 * @returns {String}
			 */
			set: function(newValue) {
				if ('' === newValue) {
					newValue = 'US';
				}

				return newValue;
			}
		},
		Country: {
			serialize: false
		},
		state: {
			type: "string",
			value: "",
			/**
			 * Defaults state to an empty string if it is NULL.
			 * @param {mixed} newValue
			 * @returns {String}
			 */
			set: function(newValue) {
				if (null === newValue) {
					newValue = '';
				}

				return newValue;
			}
		}
	}
});

/**
 * Instance of ProgressClass used to track route and page state. Must be one
 * instance so it can be used in viewModel.Progress and in can.route.map.
 * @type VaultAddress
 */
var VaultAddressObj = new VaultAddress();

if ('undefined' !== typeof Acima) {
	const acima = new Acima.Client({
		merchantId: acimaLocationGuid,
		iframeUrl: acimaiframeUrl
	});

	/**
	 * Acima constructor function.
	 * @function AcimaClass
	 */
	var AcimaClass = can.Construct('AcimaClass', {
		init: function() {
			this.loadAcima();
		},
		loadAcima: function() {
			let viewModel = $('checkout-main').viewModel(),
				element = $('.checkout-payment-btn').get(0),
				CartItems = [],
				checkoutItems = viewModel.attr('Items'),
				checkoutItemIds = Object.keys(checkoutItems);

			checkoutItemIds.forEach((Item) => {
				let priceAfterRebate = (checkoutItems[Item].priceAfterRebate
						? (checkoutItems[Item].priceAfterRebate).replace(/\,/g, '')
						: null
					),
					cartItem = {
						productId: Item,
						productName: checkoutItems[Item].name,
						unitPrice: parseInt((priceAfterRebate * 100).toFixed(2)),
						quantity: parseInt(checkoutItems[Item].quantity)
					};

				if (null != checkoutItems[Item].priceAfterRebate) {
					CartItems.push(cartItem);
				}

				// Add accessories.
				if (checkoutItems[Item].accessories) {
					let cartItemAccessories = checkoutItems[Item].accessories;

					cartItemAccessories.forEach((Accessory) => {
						let accessoryPriceAfterRebate = (Accessory.priceAfterRebate
								? (Accessory.priceAfterRebate).replace(/\,/g, '')
								: null
							),
							cartItem = {
								productId: Accessory.id,
								productName: Accessory.name,
								unitPrice: parseInt((accessoryPriceAfterRebate * 100).toFixed(2)),
								quantity: parseInt(Accessory.quantity)
							};

						if (null != Accessory.priceAfterRebate) {
							CartItems.push(cartItem);
						}
					});
				}

				// Add warranty.
				if (checkoutItems[Item].warranty) {
					let cartItemWarranty = checkoutItems[Item].warranty,
						warrantyPrice = (cartItemWarranty.price
								? (cartItemWarranty.price).replace(/\,/g, '')
								: null
						),
						cartItem = {
							productId: cartItemWarranty.id,
							productName: cartItemWarranty.name,
							unitPrice: parseInt((warrantyPrice * 100).toFixed(2)),
							quantity: parseInt(cartItemWarranty.quantity)
						};

					if (null != cartItemWarranty.price) {
						CartItems.push(cartItem);
					}
				}
			});
			acima.checkout({
				// The customer object and all of its fields are optional
				// The customer can fill or modify them within the iframe
				customer: {
					firstName: viewModel.Customer.attr('first_name'),
					middleName: "",
					lastName: viewModel.Customer.attr('last_name'),
					phone: viewModel.Customer.attr('phone'),
					email: viewModel.Customer.attr('email'),
					address: {
						street1: viewModel.ShippingAddress.attr('address_1'),
						street2: viewModel.ShippingAddress.attr('address_2'),
						city: viewModel.ShippingAddress.attr('city'),
						state: viewModel.ShippingAddress.attr('state'),
						zipCode: viewModel.ShippingAddress.attr('zip')
					}
				},
				// A transaction contains all of the details of a customer's order
				// These details are used to create the lease terms that the customer will agree to
				transaction: {
					id: viewModel.Order.attr('id'),
					discounts: parseInt(viewModel.calculatedUsedCredit() * 100),
					shipping: parseInt((viewModel.Order.attr('shipping_fee') * 100).toFixed(2)),
					salesTax: parseInt((viewModel.Order.attr('sales_tax') * 100).toFixed(2)),
					lineItems: CartItems,
					merchantReferenceNumber: viewModel.Order.attr('id'),
				}
			})
				// Listen for the pre-approval result
				.then(({leaseId, leaseNumber, checkoutToken}) => {
					viewModel.attr('BillingAddress.same_info', '1');
					viewModel.Order.attr('payment_method_selected', 'acima');

					let Order = {
						payment_method_selected: viewModel.Order.attr('payment_method_selected'),
						cardNumber: viewModel.Order.attr('card_number'),
						cardExpirationMonth: viewModel.Order.attr('card_expiration_month'),
						cardExpirationYear: viewModel.Order.attr('card_expiration_year'),
						shipping_method: viewModel.Order.attr('shipping_method')
					};

					viewModel.doAjaxRequest(
						element,
						'/checkout/express/payment-method',
						{
							Order: Order,
							BillingAddress: viewModel.BillingAddress.serialize(),
							CheckoutForm: viewModel.CheckoutForm.serialize(),
							device_data: $('#device_data').val(),
							nonce: leaseId
						},
						false
					);
				})
				// Listen for any errors or interruptions in the customer's application
				.catch(({code, message}) => {
					logError(message);
				});
		}
	});
}

/**
 * Apple Pay constructor function.
 * @function ApplePayClass
 */
var ApplePayClass = can.Construct('ApplePayClass', {
	/**
	 * Initializes the instance.
	 * @returns {undefined}
	 */
	init: function() {
		this.loadApplePay();
	},
	loadApplePay: function() {
		if (!window.ApplePaySession) {
			// Do nothing.
		} else if (!ApplePaySession.canMakePayments()) {
			// Do nothing.
		} else {
			braintree.client.create({
				authorization: brainTreeAuthorizationToken
			}, function(clientErr, clientInstance) {
				if (clientErr) {
					logError('Error creating client:'+ clientErr);

					return;
				}

				braintree.applePay.create({
					client: clientInstance
				}, function(applePayErr, applePayInstance) {
					if (applePayErr) {
						logError('Error creating applePayInstance:'+ applePayErr);

						return;
					}

					// Set an apple pay button.
					$('.btn-apple-pay-checkout').removeClass('d-none')
						.addClass('d-flex')
						.click(function() {
							let viewModel = $('checkout-main').viewModel();

							viewModel.trackEvent('Summary', 'Checkout Last Step button: Apple Pay');

							let paymentRequest = applePayInstance.createPaymentRequest({
								lineItems: [
									{
										label: "Subtotal",
										amount: viewModel.Order.attr('subTotal').toString()
									},
									{
										label: "Tax",
										amount: viewModel.Order.attr('sales_tax').toString()
									},
									{
										label: "Shipping",
										amount: viewModel.Order.attr('shipping_fee').toString()
									}
								],
								total: {
									label: "Sonicelectronix",
									amount: viewModel.calculatedTotal().toString()
								},
								requiredBillingContactFields: ["postalAddress"]
							});

							let session = new ApplePaySession(3, paymentRequest);

							session.onvalidatemerchant = function(event) {
								applePayInstance.performValidation({
									validationURL: event.validationURL,
									displayName: "Sonicelectronix"
								}, function(err, merchantSession) {
									if (err) {
										// You should show an error to the user, e.g. 'Apple Pay failed to load.'
										logError(err);

										return;
									}
									session.completeMerchantValidation(merchantSession);
								});
							};

							session.onpaymentauthorized = function(event) {
								applePayInstance.tokenize({
									token: event.payment.token
								}, function(tokenizeErr, payload) {
									if (tokenizeErr) {
										logError('Error tokenizing Apple Pay:', tokenizeErr);
										session.completePayment(ApplePaySession.STATUS_FAILURE);

										return;
									}

									let element = $('#apple-pay-button-container').get(0),
										Order = {
											payment_method_selected: viewModel.Order.attr('payment_method_selected'),
											cardNumber: viewModel.Order.attr('card_number'),
											cardExpirationMonth: viewModel.Order.attr('card_expiration_month'),
											cardExpirationYear: viewModel.Order.attr('card_expiration_year'),
											shipping_method: viewModel.Order.attr('shipping_method')
										};

									viewModel.attr('BillingAddress.same_info', '0');
									viewModel.setApplePayBillingAddress(event.payment.billingContact);
									viewModel.Order.attr('payment_method_selected','applepay_bt');

									viewModel.doAjaxRequest(
										element,
										'/checkout/express/payment-method',
										{
											Order: Order,
											BillingAddress: viewModel.BillingAddress.serialize(),
											CheckoutForm: viewModel.CheckoutForm.serialize(),
											device_data: $('#device_data').val(),
											nonce: payload.nonce
										},
										false
									);

									session.completePayment(ApplePaySession.STATUS_SUCCESS);
								});
							};
							session.begin();
						});
				});
			});
		}
	}
});

/**
 * Adds event functionality to ApplePayClass prototype.
 * Now can.event is included in the prototype, we can add/remove/dispatch events on the object instances.
 */
can.extend(ApplePayClass.prototype, can.event);

/**
 * Paypal constructor function.
 * @function PaypalClass
 */
var PaypalClass = can.Construct('PaypalClass', {
	init: function() {
		this.loadPaypal();
	},
	loadPaypal: function() {
		braintree.client.create({
			authorization: brainTreeAuthorizationToken
		}).then(function(clientInstance) {
			return braintree.paypalCheckout.create({
				client: clientInstance
			});
		}).then(function(paypalCheckoutInstance) {
			return paypalCheckoutInstance.loadPayPalSDK({
				currency: "USD",
				intent: "authorize"
			});
		}).then(function(paypalCheckoutInstance) {
			let viewModel = $('checkout-main').viewModel();

			return paypal.Buttons({
				fundingSource: paypal.FUNDING.PAYPAL,
				style: {
					// horizontal | vertical
					layout: "horizontal",
					// medium | large | responsive
					size:   "responsive",
					// pill | rect
					shape:  "rect",
					// gold | blue | silver | black
					color:  "blue",
					tagline: false,
					// max height is 55 if this is false
					// auto adapts to container
					disableMaxHeight: true
				},

				createOrder: function() {
					let paymentMethodVal = 'paypal_express';

					// Update the route.
					can.route.attr({
						section: "paymentMethod",
						paymentOption: can.camelize(paymentMethodVal.replace('_', '-'))
					});

					viewModel.trackEvent('Summary', 'Checkout Last Step button: PayPal');

					return paypalCheckoutInstance.createPayment({
						// Required
						flow: "checkout",
						// Required
						amount: parseFloat($('.cart-total b').text().replace('$', '')),
						// Required, must match the currency passed in with loadPayPalSDK
						currency: "USD",
						// Must match the intent passed in with loadPayPalSDK
						intent: "authorize",
						no_shipping: "2",
						enableShippingAddress: true,
						shippingAddressEditable: false,
						shippingAddressOverride: {
							recipientName: viewModel.ShippingAddress.attr('first_name') + ' ' + viewModel.ShippingAddress.attr('last_name'),
							line1: viewModel.ShippingAddress.attr('address_1'),
							line2: viewModel.ShippingAddress.attr('address_2'),
							city: viewModel.ShippingAddress.attr('city'),
							countryCode: viewModel.ShippingAddress.attr('country'),
							postalCode: viewModel.ShippingAddress.attr('zip'),
							state: viewModel.ShippingAddress.attr('state'),
							phone: viewModel.ShippingAddress.attr('phone')
						}
					});
				},
				onApprove: function(data, actions) {
					return paypalCheckoutInstance.tokenizePayment(data).then(function(payload) {
						// Submit `payload.nonce` to your server
						let element = $('#apple-pay-button-container').get(0);

						viewModel.attr('BillingAddress.same_info', '0');
						viewModel.setPaypalBillingAddress(payload.details.shippingAddress);
						viewModel.Order.attr('payment_method_selected','paypal_express');

						let Order = {
							payment_method_selected: viewModel.Order.attr('payment_method_selected'),
							cardNumber: viewModel.Order.attr('card_number'),
							cardExpirationMonth: viewModel.Order.attr('card_expiration_month'),
							cardExpirationYear: viewModel.Order.attr('card_expiration_year'),
							shipping_method: viewModel.Order.attr('shipping_method')
						};

						viewModel.doAjaxRequest(
							element,
							'/checkout/express/payment-method',
							{
								Order: Order,
								BillingAddress: viewModel.BillingAddress.serialize(),
								CheckoutForm: viewModel.CheckoutForm.serialize(),
								device_data: $('#device_data').val(),
								nonce: payload.nonce
							},
							false
						);
					});
				},
				onError: function(err) {
					logError(err);
				}
			}).render('#paypal-button');
		}).then(function() {
			// The PayPal button will be rendered in an html element with the ID
			// `paypal-button`. This function will be called when the PayPal button
			// is set up and ready to be used
		});
	}
});

if ('undefined' !== typeof viewModelProperties) {
	/**
	 * Combine the properties from the views with the default values.
	 * @type Object
	 */
	var viewModelDefenition = can.extend(viewModelProperties, {
		Progress: Progress,
		VaultAddress: VaultAddressObj,
		useAutocomplete: true,
		define: {
			BillingAddress: {
				Type: BillingAddress
			},
			CheckoutForm: {
				Type: CheckoutForm
			},
			Customer: {
				Type: Customer
			},
			Order: {
				Type: Order
			},
			ShippingAddress: {
				Type: ShippingAddress
			}
		},

		/**
		 * Initiates an AJAX request to add an item to the cart.
		 * @param {Element} el The DOM element that triggered the action.
		 * @returns {undefined}
		 */
		addItem: function(el) {
			let deferred = this.doAjaxRequest(
				el,
				'/checkout/express/add',
				{item: $(el).data('item')},
				false
			);

			this.restoreValuesAfterAjax(deferred);
		},
		/**
		 * Handles additional tasks upon section is shown after AJAX call
		 * @param {String|Boolean} section The name of the section in the checkout flow that was just shown.
		 *                                 TRUE if the section did not change and FALSE if the section did not
		 *                                 change but you want the GoogleApiInstance autocomplete to initialize.
		 * @returns {undefined}
		 */
		afterSectionRouted: function(section) {
			if ('undefined' !== typeof GoogleApiInstance
				&& ('shippingAddress' === section || 'paymentMethod' === section || !section)
			) {
				GoogleApiInstance.dispatch('autocomplete', [this.attr('useAutocomplete')]);
			}
		},
		/**
		 * Calculates the tax value based on the changes in the Shipping Address form.
		 * This is a helper so the user can see changes before they submit the form.
		 * All definitive values always come from the server.
		 * @returns {Number}
		 */
		calculatedTax: function() {
			let country = this.attr('ShippingAddress').attr('country'),
				state = this.attr('ShippingAddress').attr('state'),
				tax = 0;

			if ('US' === country && state) {
				let taxRate = this.attr('taxRates').attr(state),
					taxableTotal = this.attr('Order').attr('taxableTotal');

				if (taxRate) {
					tax = (taxRate / 100 * taxableTotal);
				}
			}

			return tax.toFixed(2);
		},
		/**
		 * Determines the Tax percentage based on the address changes in the Shipping Address form.
		 * @returns {String}
		 */
		calculatedTaxPercent: function() {
			let country = this.attr('ShippingAddress').attr('country'),
				state = this.attr('ShippingAddress').attr('state'),
				taxRate = '';

			if ('US' === country) {
				taxRate = this.attr('taxRates').attr(state);
			}

			return taxRate;
		},
		/**
		 * Calculates the order total. This is a helper to show the user what the order
		 * totals would be before they submit the form.  The difinitive totals always
		 * come from the server.
		 * @returns {Number}
		 */
		calculatedTotal: function() {
			let Order = this.attr('Order'),
				country = this.attr('ShippingAddress').attr('country'),
				subTotal = Order.attr('subTotal') * 1,
				caDuties = Order.attr('caDuties') * 1,
				calculatedTax = this.calculatedTax() * 1,
				shippingFee = Order.attr('shipping_fee') * 1,
				fee = Order.attr('fee') * 1,
				credit = this.calculatedUsedCredit(),
				calculatedTotal = subTotal + calculatedTax + shippingFee + fee - credit;

			// Only check duties for Canadian orders.
			if ('CA' === country) {
				calculatedTotal = calculatedTotal + caDuties;
			}

			// Prevent negative values.
			if (calculatedTotal < 0.01) {
				calculatedTotal = 0;
			}

			setCartTotal(calculatedTotal.toFixed(2));

			return calculatedTotal.toFixed(2);
		},
		/**
		 * Calculates the credit total the customer wants to use.
		 * @returns {Number}
		 */
		calculatedUsedCredit: function() {
			let CheckoutForm = this.attr('CheckoutForm'),
				useSonicbux = CheckoutForm.attr('useSonicbux'),
				useStoreCredit = CheckoutForm.attr('useStoreCredit'),
				sonicBux = ('1' === useSonicbux ? (CheckoutForm.attr('useSonicbuxAmount') * 1) : 0),
				storeCredit = ('1' === useStoreCredit ? (CheckoutForm.attr('useStoreCreditAmount') * 1) : 0),
				credit = sonicBux + storeCredit;

			return credit.toFixed(2);
		},
		/**
		 * Calculates the remaining Sonic credit.
		 * @returns {Number}
		 */
		calculatedRemainingSonicCredit: function() {
			let CheckoutForm = this.attr('CheckoutForm'),
				useStoreCredit = CheckoutForm.attr('useStoreCredit'),
				maxStoreCredit = CheckoutForm.attr('maxStoreCredit'),
				storeCredit = ('1' === useStoreCredit ? (CheckoutForm.attr('useStoreCreditAmount') * 1) : 0),
				remainingCredit = maxStoreCredit - storeCredit;

			return remainingCredit.toFixed(2);
		},
		/**
		 * Calculates the remaining Sonic Bux.
		 * @returns {Number}
		 */
		calculatedRemainingSonicBux: function() {
			let CheckoutForm = this.attr('CheckoutForm'),
				useSonicbux = CheckoutForm.attr('useSonicbux'),
				maxSonicBux = CheckoutForm.attr('maxSonicbux'),
				sonicBux = ('1' === useSonicbux ? (CheckoutForm.attr('useSonicbuxAmount') * 1) : 0),
				remainingBux = maxSonicBux - sonicBux;

			return remainingBux.toFixed(2);
		},
		/**
		 * Clears all errors within an element.
		 * @param {Element} el The DOM element to remove the errors from.
		 * @returns {undefined}
		 */
		clearErrors: function(el) {
			$(el).find('.has-error')
				.removeClass('has-error')
				.find('.help-block')
				.html('');
		},
		/**
		 * Clears all product errors within the order summary.
		 * @returns {undefined}
		 */
		clearProductViolations: function() {
			$('.orderItemSummarySection .itemInformation')
				.removeClass('alert-danger')
				.next('.help-block')
				.html('');
		},
		/**
		 * Displays errors in a form.
		 * @param {Object[]} errors Index value should be the jQuery selector of the input receiving the error.
		 * @returns {undefined}
		 */
		displayErrors: function(errors) {
			can.each(errors, function(value, index) {
				$('#' + index).parent().addClass('has-error');
				$('#' + index + '_error').html(value[0]).parent().addClass('has-error');
			});
		},
		/**
		 * Displays product errors. Usually international shipping error for a product.
		 * @param {Object[]} violations Index value should be the jQuery selector of the input receiving the error.
		 * @returns {undefined}
		 */
		displayProductViolations: function(violations) {
			can.each(violations, function(value, index) {
				let message = '';

				switch (index) {
					case 'availability':
						message = 'Item not available for International shipping.';

						break;

					case 'manufacturer':
						let $countrySelected = $('#ShippingAddress_country :selected');

						if ($countrySelected.length > 0) {
							message = 'Item not available for shipping to ' + $countrySelected.text() + '.';
						} else {
							message = 'Item not available for shipping to country selected.';
						}

						break;

					case 'warranties':
						message = 'Warranty not available outside the United States or Canada.';

						break;
				}
				can.each(value, function(itemId) {
					$('#item-' + itemId).addClass('alert-danger')
						.next('.help-block').html(
							'<div class="alert alert-danger" role="alert"><i class="fa fa-exclamation-triangle"></i> ' + message + '<p class="text-right"><a href="javascript:;" class="remove-item-link alert-link" data-item="' + itemId + '"><i class="fa fa-times"></i> Click here to remove it from the order.</a></p></div>'
						);
				});
			});
		},
		/**
		 * Performs an AJAX request. This is a common function that encapsultaes the
		 * repetitive code of performing an AJAX request.
		 * @param {Element} el The DOM element that triggered the action. The parent
		 *     '.form' element will receive the blockUI animation.
		 * @param {String} url the URL to send the AJAX request to.
		 * @param {Object} formData The data object to include in the AJAX request.
		 * @param {String|Boolean} nextStep A jQuery selector specifying the DOM element to receive focus
		 *                                  on completion. TRUE if no next step and FALSE if no next step
		 *                                  but you want the GoogleApiInstance autocomplete to initialize.
		 * @returns {can.Deferred}
		 */
		doAjaxRequest: function(el, url, formData, nextStep) {
			let form = $(el).closest('.form');

			this.clearErrors(form);

			// Keep the flash messages if nextStep isn't provided,
			// so users can see controller or backend errors.
			if (nextStep !== false) {
				$('.flash-container').empty();
			}

			form.block();

			let canDeferred = can.ajax({
				url: url,
				dataType: "json",
				data: formData,
				method: "POST",
				complete: function() {
					form.unblock();
				},
				success: function(data) {
					if (('object' === typeof data) && (null !== data)) {
						// if data has redirect and gtm has event
						// a callback that redirects will be added to the event in gtm
						// making sure all appropriate tags were triggered before the redirect
						let hasGtmRedirectCallback = false,
							willRedirect = data.hasOwnProperty('redirect'),
							viewModel = $('checkout-main').viewModel();

						// This must happen before redirect just in case.
						if (data.hasOwnProperty('gtm')) {
							if ('undefined' !== typeof window.dataLayer) {
								let gtmLastIndex = data.gtm.length - 1,
									redirectTo = data.redirect;

								can.each(data.gtm, function(value, index) {
									if (willRedirect &&
										index == gtmLastIndex &&
										value.hasOwnProperty('event')
									) {
										value["eventCallback"] = function() {
											window.location = redirectTo;
										};
										// will force to call the callback after the timeout
										// in case of an error with the tags, or the event stall
										value["eventTimeout"] = 1500;
										// let the redirect below know that it should do nothing
										hasGtmRedirectCallback = true;
									}
									window.dataLayer.push(value);
								});
							}
						}

						if(data.hasOwnProperty('cashApp')) {
							cashApp.getInstance(data.cashApp).open();
						} else if (willRedirect) {
							if (!hasGtmRedirectCallback) {
								window.location = data.redirect;
							}
						} else {
							// Updated model data sent back.
							if (data.hasOwnProperty('models')) {
								can.each(data.models, function(value, index) {
									viewModel.attr(index, value);
								});
							}

							// No errors.
							if (data.success) {
								// Next step provided.
								if (data.hasOwnProperty('nextStep')) {
									can.route.attr('section', data.nextStep);
									viewModel.afterSectionRouted(data.nextStep);
								} else if (nextStep) {
									can.route.removeAttr('token');
									can.route.attr('section', nextStep);
									viewModel.afterSectionRouted(nextStep);
								}

								if (data.hasOwnProperty('isOptedInTextMsg')) {
									if (1 == data.isOptedInTextMsg) {
										viewModel.sendOTPInText();
										$('.quickCheckoutTooltip').removeClass('no-display');
									} else {
										viewModel.showPasswordModal();
										$('.welcome-message').text('Welcome back ' + data.firstName + '!');
									}
								}

								if (data.hasOwnProperty('otpShow')) {
									$('.passwordModal .otp-block-step').removeClass('no-display')
										.siblings().addClass('no-display');

									if (viewModel.attr('textMessagePhoneNumber')) {
										$('.otp-message').text('Enter the 6-digit code sent to your email address and phone number ending in ' + viewModel.attr('textMessagePhoneNumber').substr(viewModel.attr('textMessagePhoneNumber').length - 4));
									}

									viewModel.showPasswordModal();
								}

								if (data.hasOwnProperty('password')) {
									let enterPasswordModal = $('.passwordModal .enter-password-modal');

									enterPasswordModal.removeClass('no-display')
										.siblings().addClass('no-display');

									enterPasswordModal.filter('.socialLogin').addClass('no-display');

									viewModel.showPasswordModal();
								}

								if (data.hasOwnProperty('messageType')) {
									viewModel.showPasswordModal();
									if ('email' == data.messageType) {
										$('.otp-message').text('Enter the 6-digit code code sent to your email address ' + viewModel.Customer.attr('email'));
									} else {
										$('.customer-contact-info')
											.text(data.email + ' | (***)-***-' + data.phone.substr(data.phone.length - 4));

										$('.passwordModal .otp-block-step').removeClass('no-display')
											.siblings().addClass('no-display');

										$('.otp-message').text('Enter the 6-digit code sent to your phone number ending in ' + data.phone.substr(data.phone.length - 4));
									}
									viewModel.showOTPModal();
								}

								if (data.hasOwnProperty('hasSocial')) {
									viewModel.showSocialButton(data.hasSocial);
								}

								if (data.hasOwnProperty('address')) {
									viewModel.submitShippingAddress(el);
								}

								// Fill City and state from zipcode.
								if (data.hasOwnProperty('zipcodeData')) {
									viewModel.ShippingAddress.attr('city', data.zipcodeData['city']);
									viewModel.ShippingAddress.attr('state', (data.zipcodeData['region']).toUpperCase());
								}

								if (data.hasOwnProperty('addressUpdated')) {
									let viewModel = $('checkout-main').viewModel(),
										BillingAddress = viewModel.attr('BillingAddress'),
										addressId = data.addressBookId,
										SelectedAddress = null;

									if (viewModel.attr('AddressBookEntries')) {
										SelectedAddress = viewModel.attr('AddressBookEntries').attr(addressId);
									}

									BillingAddress.attr('first_name', SelectedAddress ? SelectedAddress.attr('first_name') : '');
									BillingAddress.attr('last_name', SelectedAddress ? SelectedAddress.attr('last_name') : '');
									BillingAddress.attr('company', SelectedAddress ? SelectedAddress.attr('company') : '');
									BillingAddress.attr('address_1', SelectedAddress ? SelectedAddress.attr('address_1') : '');
									BillingAddress.attr('address_2', SelectedAddress ?  SelectedAddress.attr('address_2') : '');
									BillingAddress.attr('city', SelectedAddress ? SelectedAddress.attr('city') : '');
									BillingAddress.attr('state', SelectedAddress ?  SelectedAddress.attr('state') : '');
									BillingAddress.attr('zip', SelectedAddress ?  SelectedAddress.attr('zip') : '');
									BillingAddress.attr('country', SelectedAddress ?  SelectedAddress.attr('country') : '');
									BillingAddress.attr('phone', SelectedAddress ?  SelectedAddress.attr('phone_1') : '');
									BillingAddress.attr('address_book_address_id', SelectedAddress ? addressId : '0');

									let el = $("#BillingAddress_address_book_address_id_" + data.addressBookId);

									$('.billing-address-book').removeClass('d-none');
									$('.billing-address-form').addClass('d-none');
									$('.address-book-table').removeClass('show');

									let addressBook = el.closest('.address-book'),
										addressLabel = addressBook.find('span.address-placeholder').clone(),
										selectedAddressPlaceholder = $('.selected-address-placeholder');

									if (addressBook.hasClass('info')) {
										selectedAddressPlaceholder.html(addressLabel);
									}
								}

								viewModel.afterSectionRouted(nextStep);
							// Errors.
							} else {
								// Data errors.
								if (data.hasOwnProperty('errors')) {
									if (data.hasOwnProperty('otpLogin')) {
										let errors = [];

										can.each(data.errors, function(value) {
											errors.push(value[0]);
										});

										$('.otp-alert-warning-message').removeClass('no-display').html(errors.join('<br>'));
									} else {
										viewModel.displayErrors(data.errors);
									}
								}

								// Shipping restrictions.
								if (data.hasOwnProperty('shippingAddressHasErrors')) {
									if (data.hasOwnProperty('productIntlViolations')) {
										viewModel.displayProductViolations(data.productIntlViolations);
									}
									can.route.attr('section', 'shippingAddress');
								}

								// Alert.
								if (data.hasOwnProperty('alertMessage')) {
									if (data.hasOwnProperty('otpLogin')) {
										$('.otp-alert-warning-message').removeClass('no-display').html(data.alertMessage);
									} else {
										viewModel.showAlertMessage(data.alertMessage);
									}
								}

								// Warning.
								if (data.hasOwnProperty('warningMessage')) {
									viewModel.showWarningMessage(data.warningMessage);
								}

								// Card mismatch Error
								if (data.hasOwnProperty('mismatchError')) {
									if (data.hasOwnProperty('errorMessage')) {
										$('.card-holder-name-input').addClass('d-none');
										$('.verify-card-details').addClass('card-mismatch-error')
											.removeClass('card-verification-error')
											.removeClass('d-none');
									}
								}
							}
						}
					} else {
						alert('A communication error has occurred. Please contact us for assistance.');
					}
				}
			});

			return canDeferred;
		},
		/**
		 * Submits AJAX request to get and update city and state for ShippingAddress.
		 * @param {Element} el The DOM element that triggered the action.
		 * @returns {undefined}
		 */
		getCityState: function(el) {
			let zipPattern = /^\d{5}$/;

			if ((this.ShippingAddress.attr('zip')).match(zipPattern)) {
				this.doAjaxRequest(
					el,
					'/checkout/express/zipcode',
					{
						zipcode: this.ShippingAddress.attr('zip')
					},
					false
				);
			}
		},
		/**
		 * Determine and show card icon and show/hide additional card fields based on card number input.
		 * @param {Element} el The DOM element that triggered the action.
		 * @returns {undefined}
		 */
		handleCardInput: function(el) {
			let cardNumber = $.trim($(el).val()),
				cardType = false;

			// Card number begins with digit
			if (cardNumber.match(/^\d/)) {
				// These BIN patterns come from CardNumberValidator::getBinPatterns().
				let amexReg = new RegExp("^3[47]"),
					dinersReg = new RegExp("^36"),
					discoverReg = new RegExp("^(6011|64[4-9]|65)"),
					jcbReg = new RegExp("^(352[8-9]|35[3-8][0-9])"),
					masterCardReg = new RegExp("^5[1-5]|^(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[0-1][0-9]|2720)"),
					unionReg = new RegExp("^62"),
					visaReg = new RegExp("^4");

				if (cardNumber.match(visaReg) !== null) {
					cardType = "visa";
				} else if (cardNumber.match(masterCardReg) !== null) {
					cardType = "mastercard";
				} else if (cardNumber.match(amexReg) !== null) {
					cardType = "amex";
				} else if (cardNumber.match(discoverReg) !== null) {
					cardType = "discover";
				} else if (cardNumber.match(dinersReg) !== null) {
					cardType = "dinersClub";
				} else if (cardNumber.match(jcbReg) !== null) {
					cardType = "jcb";
				} else if (cardNumber.match(unionReg) !== null) {
					cardType = "unionPay";
				}

				if (cardType) {
					$('.cc-number-container .icon.' + cardType).css({'display': 'block'}).siblings().css({'display': 'none'});
				}

				if (cardType == "amex") {
					$('.cvv-4-digit').removeClass('d-none');
					$('.cvv-3-digit').addClass('d-none');
				} else {
					$('.cvv-3-digit').removeClass('d-none');
					$('.cvv-4-digit').addClass('d-none');
				}

			}

			if (false === cardType) {
				$('.cc-number-container .creditCardIconWrapper .icon').css({'display': 'none'});
			}

			if (cardNumber.length > 5) {
				$('.cc-number-outer-container').removeClass('mb-0').addClass('mb-2');
				$('.cc-other-info-container').fadeIn('fast');
			}
		},
		/**
		 * Determines if the event was an enter key event.
		 * @param {Object} e the event object.
		 * @returns {Boolean} TRUE if the event was from the "Enter" key. FALSE otherwise.
		 */
		isEnterKeyEvent: function(e) {
			return 13 === e.which;
		},
		/**
		 * Prevents Chrome/browser Autofill from interfering with Google Places autocomplete
		 * on the billing address_1 field. Keep autocomplete suppressed on blur so the browser
		 * does not overwrite the address filled by our Google Places selection.
		 * @return {undefined}
		 */
		onOrderAddressBlurEvent: function() {
			$('#OrderAddress_address_1').attr('autocomplete', 'section-billing address-line1');
			$('#BillingAddress_address_1').attr('autocomplete', 'section-billing address-line1');
		},
		onOrderAddressFocusEvent: function() {
			$('#OrderAddress_address_1').attr('autocomplete', 'new-password');
			$('#BillingAddress_address_1').attr('autocomplete', 'new-password');
		},
		/**
		 * Prevents Chrome/browser Autofill from interfering with Google Places autocomplete
		 * on the shipping address_1 field.
		 * @return {undefined}
		 */
		onShipAddressBlurEvent: function() {
			$('#ShippingAddress_address_1').attr('autocomplete', 'section-shipping address-line1');
		},
		onShipAddressFocusEvent: function() {
			$('#ShippingAddress_address_1').attr('autocomplete', 'new-password');
		},
		/**
		 * Performs AJAX request to remove a coupon from the cart.
		 * @param {Element} el The DOM element that triggered the action.
		 * @returns {undefined}
		 */
		removeCartCoupon: function(el) {
			let deferred = this.doAjaxRequest(
				el,
				'/checkout/express/remove',
				{
					couponCodeId: $(el).data('couponCodeId')
				},
				false
			);

			this.restoreValuesAfterAjax(deferred);
		},
		/**
		 * Performs AJAX request to remove an item from the cart.
		 * @param {Element} el The DOM element that triggered the action.
		 * @returns {undefined}
		 */
		removeItem: function(el) {
			let deferred = this.doAjaxRequest(
				el,
				'/checkout/express/remove',
				{item: $(el).data('item')},
				false
			);

			this.restoreValuesAfterAjax(deferred);
		},
		/**
		 * Restores form values of form after AJAX call completes. Currently only
		 * shipping method form is implemented.
		 * @param {can.Deferred} deferred AJAX Promise.
		 * @returns {undefined}
		 */
		restoreValuesAfterAjax: function(deferred) {
			let section = this.Progress.attr('section'),
				shippingMethod = false;

			if ('shippingMethod' === section) {
				shippingMethod = this.Order.attr('shipping_method');
			}

			deferred.done(function() {
				if (shippingMethod) {
					let viewModel = $('checkout-main').viewModel(),
						ShippingMethods = viewModel.attr('ShippingMethods');

					if (ShippingMethods.attr(shippingMethod)) {
						viewModel.attr('Order').attr('shipping_method', shippingMethod);
					} else {
						viewModel.displayErrors({
							Order_shipping_method: [
								'The shipping method selected is no longer available.'
							]
						});
					}
					$('.order-shipping-method-radio:checked').trigger('change');
				}
			});
		},
		/**
		 * Sends a text message containing one-time-password to customer
		 * @returns {undefined}
		 */
		sendOTPInText: function() {
			let requestOtpElement = $('.request-otp').get(0);

			this.doAjaxRequest(
				requestOtpElement,
				'/checkout/express/request-otp',
				{
					email: this.Customer.attr('email')
				},
				false
			);
		},
		/**
		 * Returns TRUE if there are available shipping methods, FALSE otherwise.
		 * @returns {Boolean}
		 */
		shippingMethodsAvailable: function() {
			return can.isEmptyObject(this.attr('ShippingMethods'));
		},
		/**
		 * Displays a danger flash message on the page.
		 * @param {String} alertMessage The message to add to the alert HTML element.
		 * @returns {undefined}
		 */
		showAlertMessage: function(alertMessage) {
			$('.flash-container').append(
				$('<div class="alert alert-danger alert-dismissible d-flex align-items-center" role="alert" style="gap: 1rem;">'
					+ '<div><i class="fa fa-exclamation-triangle fa-2x visible-xs-block"></i></div>'
					+ '<div>' + alertMessage + '</div>'
					+ '<div><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>'
					+ '</div>')
			);
		},
		/**
		 * Sets attribute values for BillingAddress.
		 * @param {BillingAddress} billingAddress
		 * @returns {undefined}
		 */
		setBillingAddress: function(billingAddress) {
			this.BillingAddress.attr('first_name', billingAddress.name);
			this.BillingAddress.attr('last_name', '');
			this.BillingAddress.attr('company', '');
			this.BillingAddress.attr('address_1', billingAddress.address1);
			this.BillingAddress.attr('address_2', billingAddress.address2);
			this.BillingAddress.attr('city', billingAddress.locality);
			this.BillingAddress.attr('state', billingAddress.administrativeArea);
			this.BillingAddress.attr('zip', billingAddress.postalCode);
			this.BillingAddress.attr('country', billingAddress.countryCode);
			this.BillingAddress.attr('phone', billingAddress.phoneNumber);
		},
		/**
		 * Sets attribute values for Apple pay BillingAddress.
		 * @param {BillingAddress} billingAddress
		 * @returns {undefined}
		 */
		setApplePayBillingAddress: function(billingAddress) {
			let addressLine2 = billingAddress.addressLines[1] ? billingAddress.addressLines[1] : '';

			this.BillingAddress.attr('first_name', billingAddress.givenName);
			this.BillingAddress.attr('last_name', billingAddress.familyName);
			this.BillingAddress.attr('company', '');
			this.BillingAddress.attr('address_1', billingAddress.addressLines[0]);
			this.BillingAddress.attr('address_2', addressLine2);
			this.BillingAddress.attr('city', billingAddress.locality);
			this.BillingAddress.attr('state', billingAddress.administrativeArea);
			this.BillingAddress.attr('zip', billingAddress.postalCode);
			this.BillingAddress.attr('country', billingAddress.countryCode);
			this.BillingAddress.attr('phone', billingAddress.phoneNumber);
		},
		/**
		 * Sets attribute values for PayPal BillingAddress.
		 * @param {BillingAddress} billingAddress
		 * @returns {undefined}
		 */
		setPaypalBillingAddress: function(billingAddress) {
			this.BillingAddress.attr('first_name', billingAddress.recipientName);
			this.BillingAddress.attr('last_name', '');
			this.BillingAddress.attr('company', '');
			this.BillingAddress.attr('address_1', billingAddress.line1);
			this.BillingAddress.attr('address_2', billingAddress.line2);
			this.BillingAddress.attr('city', billingAddress.city);
			this.BillingAddress.attr('state', billingAddress.state);
			this.BillingAddress.attr('zip', billingAddress.postalCode);
			this.BillingAddress.attr('country', billingAddress.countryCode);
			this.BillingAddress.attr('phone', billingAddress.phoneNumber);
		},
		/**
		 * Sets attribute values for ShippingAddress.
		 * @param {ShippingAddress} shippingAddress
		 * @returns {undefined}
		 */
		setShippingAddress: function(shippingAddress) {
			this.ShippingAddress.attr('first_name', shippingAddress.first_name);
			this.ShippingAddress.attr('last_name', shippingAddress.last_name);
			this.ShippingAddress.attr('company', shippingAddress.company);
			this.ShippingAddress.attr('address_1', shippingAddress.address_1);
			this.ShippingAddress.attr('address_2', shippingAddress.address_2);
			this.ShippingAddress.attr('city', shippingAddress.city);
			this.ShippingAddress.attr('state', shippingAddress.state);
			this.ShippingAddress.attr('zip', shippingAddress.zip);
			this.ShippingAddress.attr('country', shippingAddress.country);
			this.ShippingAddress.attr('phone', shippingAddress.phone);
		},
		/**
		 * Sets attribute values for BillingAddress.
		 * @param {String} identifier
		 * @returns {undefined}
		 */
		setVaultCardBillingAddress: function(identifier) {
			let viewModel = $('checkout-main').viewModel(),
				CustomerVaultData = viewModel.attr('CustomerVault').attr(identifier),
				selectedAddressRadio = $("input[name='BillingAddress_address_book_address_id_radio']:checked"),
				BillingAddress = viewModel.attr('BillingAddress');

			BillingAddress.attr('same_info',  0);
			if (selectedAddressRadio.length > 0) {
				let deferred = viewModel.doAjaxRequest(
					selectedAddressRadio[0],
					'/checkout/express/update-credit-card',
					{
						id: identifier,
						BillingAddress: BillingAddress.serialize()
					},
					false
				);

				deferred.done(function() {
					return true;
				});
			}
			else
			{
				this.BillingAddress.attr('first_name',  CustomerVaultData.attr('billing_first_name'));
				this.BillingAddress.attr('last_name',  CustomerVaultData.attr('billing_last_name'));
				this.BillingAddress.attr('company',  CustomerVaultData.attr(''));
				this.BillingAddress.attr('address_1',  CustomerVaultData.attr('billing_street_address'));
				this.BillingAddress.attr('address_2',  CustomerVaultData.attr('billing_extended_address'));
				this.BillingAddress.attr('city',  CustomerVaultData.attr('billing_locality'));
				this.BillingAddress.attr('state',  CustomerVaultData.attr('billing_region'));
				this.BillingAddress.attr('zip',  CustomerVaultData.attr('billing_postal_code'));
				this.BillingAddress.attr('country',  CustomerVaultData.attr('billing_country_code'));
				this.BillingAddress.attr('phone', this.ShippingAddress.attr('phone'));

				return true;
			}
		},
		/**
		 * Displays a warning flash message on the page.
		 * @param {String} warningMessage The message to add to the alert HTML element.
		 * @returns {undefined}
		 */
		showWarningMessage: function(warningMessage) {
			$('.flash-container').append(
				$('<div class="alert alert-waring alert-dismissible" role="alert">'
					+ '<div class="row">'
					+ '<div class="col-xs-12"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>'
					+ '</div>'
					+ '<div class="row">'
					+ '<div class="col-xs-2 col-md-1 text-center"><i class="fa fa-exclamation-triangle fa-2x visible-xs-block"></i></div>'
					+ '<div class="col-xs-10 col-md-11">' + warningMessage + '</div>'
					+ '</div>'
					+ '</div>')
			);
		},
		/**
		 * Opens otp modal on the page.
		 * @returns {undefined}
		 */
		showOTPModal: function() {
			let $el = $('.contact-info-form input');

			// Open modal only if customer has not clicked on 'X' (closed forcefully)
			if (!$el.hasClass('checked')) {
				let otpInput = $('input.checkout-otp-input-digit');

				for (let i = 0; i < otpInput.length; i++) {
					// Allow digits only
					otpInput.eq(i).val(otpInput.eq(i).val().replace(/\D/g, ''));
				}
				$('.otp-block-step').removeClass('no-display')
					.siblings().addClass('no-display');
				otpInput.eq(0).focus();
			}
		},
		/**
		 * Opens password modal on the page.
		 * @returns {undefined}
		 */
		showPasswordModal: function() {
			let $el = $('.contact-info-form input');

			// Open modal only if customer has not clicked on 'X' (closed forcefully)
			if (!$el.hasClass('checked')) {
				$('.passwordModal .container-password').removeClass('no-display');
				$('#passwordModal').modal('show');
				let email = this.Customer.attr('email'),
					index = email.indexOf('@'),
					domain = email.slice((index + 1), email.length);

				if ('gmail.com' === domain) {
					this.showSocialButton([{"social_type": "google"}]);
				}
			}
		},
		/**
		 * Displays social-login button on enter password modal.
		 * @param {Array} social_type list of social account attached with email.
		 * @returns {undefined}
		 */
		showSocialButton: function(social_type) {
			let enterPasswordModal = $('.passwordModal .enter-password-modal');

			enterPasswordModal.filter('.socialLogin').removeClass('no-display');
			if (1 === social_type.length) {
				if ('google' === social_type[0]['social_type']) {
					enterPasswordModal.filter('.btn-social-google').attr('style', 'display: block !important');
				} else {
					enterPasswordModal.filter('.btn-social-google').attr('style', 'display: none !important');
				}
			}
		},
		/**
		 * Handles submission of the guest contact info form.
		 * @param {Element} el The DOM element that triggered the action.
		 * @returns {undefined}
		 */
		submitGuestCheckout: function(el) {
			this.doAjaxRequest(
				el,
				'/checkout/express/guest',
				{
					Customer: {
						email: $(el).val()
					}
				},
				false
			);
		},
		/**
		 * Submits the login form.
		 * @param {Element} el The DOM element that triggered the action.
		 * @returns {undefined}
		 */
		submitLogin: function(el) {
			this.doAjaxRequest(
				el,
				'/checkout/express/login',
				{
					Customer: {
						emailOrUsername: this.Customer.attr('email'),
						password: this.Customer.attr('password')
					}
				},
				(this.ShippingAddress.attr('is_default_address') ? 'shippingMethod' : false)
			);

			if (this.ShippingAddress.attr('is_default_address')) {
				this.viewModel.submitShippingAddressUpdate(el);
			}
		},
		/**
		 * Submits the otp login form.
		 * @param {Element} el The DOM element that triggered the event.
		 * @returns {undefined}
		 */
		submitOtpLogin: function(el) {
			this.doAjaxRequest(
				el,
				'/checkout/express/login',
				{
					Customer: {
						emailOrUsername: this.Customer.attr('email'),
						oneTimePasswordCode: this.Customer.attr('otp')
					},
					otp: "1"
				},
				false
			);
		},
		/**
		 * Handles submission of the new password.
		 * @param {Element} el The DOM element that triggered the event.
		 * @returns {undefined}
		 */
		submitResetPassword: function(el) {
			let token = location.search.split('token=')[1];

			this.doAjaxRequest(
				el,
				'/checkout/express/reset-password',
				{
					Customer: {
						newPassword: this.Customer.attr('newPassword'),
						confirmPassword: this.Customer.attr('confirmPassword')
					},
					token: token
				},
				'shippingMethod'
			);
		},
		/**
		 * Handles submission of the shipping address form.
		 * @param {Element} el The DOM element that triggered the action.
		 * @returns {undefined}
		 */
		submitShippingAddress: function(el) {
			this.clearProductViolations();
			if ('CA' != this.ShippingAddress.attr('country') && 'US' != this.ShippingAddress.attr('country')) {
				this.ShippingAddress.attr('state', '');
			}

			let data = {ShippingAddress: this.ShippingAddress.serialize()},
				register = this.Customer.attr('checkoutRegister');

			if (register) {
				data['Customer'] = {
					checkoutRegister: register,
					newPassword: this.Customer.attr('newPassword'),
					confirmPassword: this.Customer.attr('confirmPassword')
				};
			}
			data['Customer'] = {
				email: this.Customer.attr('email')
			};
			this.doAjaxRequest(
				el,
				'/checkout/express/shipping-address',
				data,
				'shippingMethod'
			);
			$('#passwordModal').modal('hide');
		},
		/**
		 * Submits the shipping method form.
		 * @param {Element} el The DOM element that triggered the action.
		 * @returns {undefined}
		 */
		submitShippingMethod: function(el) {
			this.doAjaxRequest(
				el,
				'/checkout/express/shipping-method',
				{
					shipping_method: this.Order.attr('shipping_method')
				},
				(this.attr('hasAvailableCredit') ? 'availableCredit' : 'paymentMethod')
			);
		},
		/**
		 * Handles submission of the payment method form.
		 * @param {Element} el The DOM element that triggered the action.
		 * @returns {undefined}
		 */
		submitPaymentMethod: function(el) {
			let viewModel = $('checkout-main').viewModel(),
				$el = $(el),
				cardIdentifier = this.Order.attr('cardIdentifier') !== 'new-card'
					? this.Order.attr('cardIdentifier') : '',
				shippingMethod = this.Order.attr('shipping_method');

			if ('paymentSubmit2' === $el.data('name')) {
				el = $('.payment-method-form .payment-method-submit').get(0);
				document.getElementById('payment-method-panel').scrollIntoView();
			} else if ($el.data('name')){
				this.Order.attr('payment_method_selected', $el.data('name'));
			}

			let Order = {
				add_to_vault: ($('#save_to_account').is(':checked') ? true : false),
				cardExpirationMonth: this.Order.attr('card_expiration_month'),
				cardExpirationYear: this.Order.attr('card_expiration_year'),
				cardNumber: this.Order.attr('card_number'),
				card_verification: viewModel.CheckoutForm.attr('csc'),
				cardholderName: this.Order.attr('cardholder_name'),
				cardIdentifier: cardIdentifier,
				payment_method_selected: this.Order.attr('payment_method_selected')
			};

			if ('NOT' === shippingMethod || null === shippingMethod) {
				Order['shipping_method'] = 'NOT';
			}

			if (cardIdentifier != '' && viewModel.attr('defaultCardReVerificationNeeded')) {
				Order['verifiedCard'] = true;
			}

			if (cardIdentifier && viewModel.setVaultCardBillingAddress(cardIdentifier)) {
				this.doAjaxRequest(
					el,
					'/checkout/express/payment-method',
					{
						Order: Order,
						BillingAddress: this.BillingAddress.serialize(),
						CheckoutForm: this.CheckoutForm.serialize(),
						device_data: $('#device_data').val()
					},
					false
				);
			}
			else
			{
				this.doAjaxRequest(
					el,
					'/checkout/express/payment-method',
					{
						Order: Order,
						BillingAddress: this.BillingAddress.serialize(),
						CheckoutForm: this.CheckoutForm.serialize(),
						device_data: $('#device_data').val()
					},
					false
				);
			}
		},
		/**
		 * Handles submission of the payment method form.
		 * @param {Element} el The DOM element that triggered the action.
		 * @returns {undefined}
		 */
		submitPaypalOrder: function(el) {
			if ('paypalSubmit2' === $(el).data('name')) {
				el = $('.paypal-confirm-form .paypal-confirm-submit').get(0);
				document.getElementById('paypal-confirm-panel').scrollIntoView();
			}

			this.doAjaxRequest(
				el,
				'/checkout/express/payment-method',
				{
					Order: {
						shipping_method: this.Order.attr('shipping_method')
					},
					CheckoutForm: this.CheckoutForm.serialize(),
					device_data: $('#device_data').val()
				},
				false
			);
		},
		/**
		 * Handles submission of shipping address update after selecting address from address-book.
		 * @param {Element} el The DOM element that triggered the action.
		 * @returns {undefined}
		 */
		submitShippingAddressUpdate: function(el) {
			this.clearProductViolations();

			let viewModel = $('checkout-main').viewModel(),
				addressId = this.ShippingAddress.attr('address_book_address_id');

			if ('CA' != this.ShippingAddress.attr('country') && 'US' != this.ShippingAddress.attr('country')) {
				this.ShippingAddress.attr('state', '');
			}
			if ('undefined' === typeof this.attr('AddressBookEntries').attr(addressId)) {
				this.ShippingAddress.attr('address_book_address_id', '0');
				this.setShippingAddress(viewModel.ShippingAddress);
			}

			let data = {ShippingAddress: this.ShippingAddress.serialize()},
				register = this.Customer.attr('checkoutRegister');

			if (register) {
				data['Customer'] = {
					checkoutRegister: register,
					newPassword: this.Customer.attr('newPassword'),
					confirmPassword: this.Customer.attr('confirmPassword')
				};
			}

			let form = $(el).closest('.form').parent().parent().siblings(),
				deferred = this.doAjaxRequest(
					form.get(0),
					'/checkout/express/shipping-address',
					data,
					false
				);

			deferred.done(function() {
				form.unblock();
				// Check if selected card needs re-verification for shipping address.
				viewModel.verifyCard(el);
			});
		},
		/**
		 * Handles submission of shipping protection.
		 * @param {Element} el The DOM element that triggered the action.
		 * @returns {undefined}
		 */
		submitShippingProtection: function(el) {
			this.doAjaxRequest(
				el,
				'/checkout/express/shipping-protection',
				{
					shippingProtectionSelected: this.CheckoutForm.attr('shippingProtectionSelected')
				},
				true
			);
		},
		/**
		 * Sends an event to Google Analytics. The event category is hard coded to
		 * 'SinglePageCheckout'.
		 * @param {String} action The Google Analytics event action.
		 * @param {String} label The Google Analytics event label.
		 * @returns {undefined}
		 */
		trackEvent: function(action, label) {
			if ('undefined' !== typeof ga) {
				ga('send', 'event', 'SinglePageCheckout', action, label);
			}
		},
		/**
		 * Updated address book's address details.
		 * @param {Element} el The DOM element that triggered the action.
		 * @returns {undefined}
		 */
		updateAddressBookAddress: function(el) {
			this.doAjaxRequest(
				el,
				'/checkout/express/update-address-book-address',
				{
					address: $('checkout-main').viewModel().attr('BillingAddress').serialize(),
					isShippingAddress: false
				},
				false
			);
		},
		/**
		 * Update billing-address with selected address from address-book.
		 * @returns {undefined}
		 */
		updateBillingAddress: function() {
			let viewModel = $('checkout-main').viewModel(),
				ShippingAddress = viewModel.attr('ShippingAddress'),
				BillingAddress = viewModel.attr('BillingAddress'),
				addressId = ShippingAddress.attr('address_book_address_id'),
				SelectedAddress = null;

			if (viewModel.attr('AddressBookEntries')) {
				SelectedAddress = viewModel.attr('AddressBookEntries').attr(addressId);
			}

			BillingAddress.attr('first_name', SelectedAddress ? SelectedAddress.attr('first_name') : '');
			BillingAddress.attr('last_name', SelectedAddress ? SelectedAddress.attr('last_name') : '');
			BillingAddress.attr('company', SelectedAddress ? SelectedAddress.attr('company') : '');
			BillingAddress.attr('address_1', SelectedAddress ? SelectedAddress.attr('address_1') : '');
			BillingAddress.attr('address_2', SelectedAddress ?  SelectedAddress.attr('address_2') : '');
			BillingAddress.attr('city', SelectedAddress ? SelectedAddress.attr('city') : '');
			BillingAddress.attr('state', SelectedAddress ?  SelectedAddress.attr('state') : '');
			BillingAddress.attr('zip', SelectedAddress ?  SelectedAddress.attr('zip') : '');
			BillingAddress.attr('country', SelectedAddress ?  SelectedAddress.attr('country') : '');
			BillingAddress.attr('phone', SelectedAddress ?  SelectedAddress.attr('phone_1') : '');
			BillingAddress.attr('address_book_address_id', SelectedAddress ? addressId : '0');
		},
		/**
		 * Submits AJAX request to update the cart.
		 * @param {Element} el The DOM element that triggered the action.
		 * @returns {undefined}
		 */
		updateCartCoupon: function(el) {
			let $el = $(el),
				deferred = this.doAjaxRequest(
					el,
					'/checkout/express/update',
					{
						coupons: $el.val(),
						customerEmail: $el.data('customer')
					},
					false
				);

			this.restoreValuesAfterAjax(deferred);
		},
		/**
		 * Submits AJAX request to update the quantity for an item in the cart.
		 * @param {Element} el The DOM element that triggered the action.
		 * @returns {undefined}
		 */
		updateProductQuantity: function(el) {
			let $el = $(el),
				deferred = this.doAjaxRequest(
					el,
					'/checkout/express/update',
					{
						item: $el.data('item'),
						quantity: $el.val()
					},
					false
				);

			this.restoreValuesAfterAjax(deferred);
		},
		/**
		 * Update shipping-address with selected address from address-book.
		 * @returns {undefined}
		 */
		updateShippingAddress: function() {
			let viewModel = $('checkout-main').viewModel(),
				ShippingAddress = viewModel.attr('ShippingAddress'),
				addressId = ShippingAddress.attr('address_book_address_id'),
				clearAddress = ('0' === addressId),
				SelectedAddress = viewModel.attr('AddressBookEntries').attr(addressId);

			if (!clearAddress) {
				SelectedAddress = viewModel.attr('AddressBookEntries').attr(addressId);
			}

			ShippingAddress.attr('first_name', clearAddress ? '' : SelectedAddress.attr('first_name'));
			ShippingAddress.attr('last_name', clearAddress ? '' : SelectedAddress.attr('last_name'));
			ShippingAddress.attr('company', clearAddress ? '' : SelectedAddress.attr('company'));
			ShippingAddress.attr('address_1', clearAddress ? '' : SelectedAddress.attr('address_1'));
			ShippingAddress.attr('address_2', clearAddress ? '' : SelectedAddress.attr('address_2'));
			ShippingAddress.attr('city', clearAddress ? '' : SelectedAddress.attr('city'));
			ShippingAddress.attr('state', clearAddress ? '' : SelectedAddress.attr('state'));
			ShippingAddress.attr('zip', clearAddress ? '' : SelectedAddress.attr('zip'));
			ShippingAddress.attr('country', clearAddress ? 'US' : SelectedAddress.attr('country'));
			ShippingAddress.attr('phone', clearAddress ? '' : SelectedAddress.attr('phone_1'));
		},
		/**
		 * Update billing-address with selected address from address-book.
		 * @param {Element} el The DOM element that triggered the action.
		 * @returns {undefined}
		 */
		verifyCard: function(el) {
			let viewModel = $('checkout-main').viewModel(),
				// Check if selected card needs re-verification for shipping address
				deferred = viewModel.doAjaxRequest(
					el,
					'/checkout/express/verify-card',
					{
						ShippingAddress: viewModel.ShippingAddress.serialize(),
						CardIdentifier: viewModel.Order.attr('cardIdentifier')
					},
					false
				);

			deferred.done(function() {
				if (deferred.responseJSON.success && deferred.responseJSON.hasOwnProperty('verificationError')) {
					$('.card-holder-name-input').addClass('d-none');
					$('.verify-card-details')
						.addClass('card-verification-error')
						.removeClass('card-mismatch-error')
						.removeClass('d-none');
					viewModel.attr('defaultCardReVerificationNeeded', true);
				} else {
					$('.verify-card-details').addClass('d-none');
					viewModel.attr('defaultCardReVerificationNeeded', false);
				}
			});
		}
	});

	/**
	 * Constructor function for the main checkout views model.
	 * @function CheckoutViewModel
	 */
	var CheckoutViewModel = can.Map.extend(viewModelDefenition);

	// The main checkout component with the default configuration values.
	can.Component.extend({
		tag: "checkout-main",
		viewModel: CheckoutViewModel,
		template: can.stache('<content/>'),
		/**
		 * All event handlers for the page should be registered through CanJS to take
		 * advantage of the automatic memory leak prevention.
		 */
		events: {
			/**
			 * Event handler to select the address radio button when the button's table row is clicked.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".address-book-table .address-book click": function(el) {
				$(el).addClass('success')
					.find('input').prop('checked', true).trigger('change')
					.end().siblings().removeClass('success');
			},
			/**
			 * Event handler to submit the add item AJAX request on click.
			 * @param {Element} el The DOM element that triggered the event.
			 * @param {Object} e The event object.
			 * @returns {undefined}
			 */
			".add-item-link click": function(el, e) {
				e.preventDefault();
				this.viewModel.addItem(el);
			},
			/**
			 * Event handler to clear the Shipping Address form when "Add new address" button click.
			 * @returns {undefined}
			 */
			".add-shipping-address click": function() {
				let ShippingAddress = this.viewModel.attr('ShippingAddress'),
					 addressId = ShippingAddress.attr('address_book_address_id');

				ShippingAddress.attr('address_book_address_id', '0');
				ShippingAddress.attr('previous_address_id', addressId);
			},
			/**
			 * Event handler to submit the available credits form on button click.
			 * @returns {undefined}
			 */
			"#available-credit-submit click": function() {
				$('.payment-body.credit_card_method').show();
				can.route.attr('section', 'paymentMethod');
				this.viewModel.trackEvent('Available Credit', 'Available Credit Submit - click');
			},
			/**
			 * Event handler to open input field for Apartment, building, floor in Billing address form.
			 * @returns {undefined}
			 */
			".billing-address-optional click": function() {
				$('#OrderAddress_address_2').removeClass('d-none')
					.siblings().removeClass('d-none');
				$('.billing-address-optional').addClass('d-none');
			},
			/**
			 * Event handler to submit billing address.
			 * @returns {undefined}
			 */
			".billing-address-submit click": function() {
				this.viewModel.updateAddressBookAddress();
			},
			/**
			 * Event handler to open acima checkout iframe.
			 * @returns {undefined}
			 */
			".btn-acima-pay click": function() {
				AcimaInstance = new AcimaClass();
			},
			/**
			 * Event handler to track the Google login click.
			 * @returns {undefined}
			 */
			".btn-social-google click": function() {
				this.viewModel.trackEvent('Checkout Method', 'Social - Google');
			},
			/**
			 * Event handler to submit the cart update AJAX request when the cart item's quantity changes.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".cart-menu .quantity change": function(el) {
				this.viewModel.updateProductQuantity(el);
				this.viewModel.trackEvent('Order Summary', 'Item Quantity Change');
			},
			/**
			 * Event handler to update coupon in cart.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".cart-menu .coupon-input change": function(el) {
				if (el.val() !== '') {
					this.viewModel.updateCartCoupon(el);
					this.viewModel.trackEvent('Order Summary', 'Cart Coupon Update');
				}
			},
			/**
			 * Event handler to remove coupon from cart.
			 * @param {Element} el The DOM element that triggered the event.
			 * @param {Object} e The event object.
			 * @returns {undefined}
			 */
			".cart-menu .remove-coupon click": function(el, e) {
				e.preventDefault();
				this.viewModel.removeCartCoupon(el);
				this.viewModel.trackEvent('Order Summary', 'Remove Cart Coupon');
			},
			/**
			 * Event handler to submit remove cart item AJAX request on click.
			 * @param {Element} el The DOM element that triggered the event.
			 * @param {Object} e The event object.
			 * @returns {undefined}
			 */
			".cart-menu .remove-item-link click": function(el, e) {
				e.preventDefault();
				this.viewModel.removeItem(el);
				this.viewModel.trackEvent('Order Summary', 'Remove Item');
			},
			/**
			 * Event handler to open change-address modal popup.
			 * @param {Element} el The DOM element that triggered the event.
			 * @param {Object} e The event object.
			 * @returns {undefined}
			 */
			".change-address a click": function(el, e) {
				e.preventDefault();

				$('#changeAddressModal').modal('show');
				this.viewModel.trackEvent('Checkout Method', 'Change Address - click');
			},
			/**
			 * Event handler to enable Sign-in button after entering entire otp.
			 * @param {Element} el The DOM element that triggered the event.
			 * @param {Object} e The event object.
			 * @returns {undefined}
			 */
			".checkout-otp-input-digit keyup": function(el, e) {
				let $el = $(el),
					key = e.keyCode || e.charCode,
					currentElement = el,
					inputs = $('input.checkout-otp-input-digit'),
					givenIndex = inputs.index(currentElement);

				if ((key >= 48 && key <= 57)
					|| (key >= 96 && key <= 105)
				) {
					$el.val(e.key);
				}

				let emptyInputs = inputs.filter(function() {
					return ('' === this.value);
				});

				// ctrl + paste event triggers twice on keyup
				// key 86 is a v/V letter
				if (86 === key) {
					return undefined;
				}

				if (0 === emptyInputs.length) {
					let otpCode = inputs.eq(0).val() + inputs.eq(1).val() + inputs.eq(2).val() + inputs.eq(3).val() + inputs.eq(4).val() + inputs.eq(5).val();

					this.viewModel.Customer.attr('otp', otpCode);
					this.viewModel.submitOtpLogin(el);
				}

				// key 48-58 num range 0-9 key in standard key location
				// key 96-105 range 0-9 from num pad
				// key 39 right arrow
				if ((key >= 48 && key <= 57)
					|| (key >= 96 && key <= 105)
					|| (39 === key)
				) {
					if ((inputs.length - 1) != givenIndex) {
						inputs.eq(givenIndex + 1).select();
					} else {
						inputs.eq(0).select();
					}
				}

				// backspace key 8 / left arrow  37
				if (8 === key || 37 === key) {
					if (0 != givenIndex) {
						inputs.eq(givenIndex - 1).select();
					} else {
						inputs.eq(inputs.length - 1).select();
					}
				}
			},
			/**
			 * Event handler to paste one-time-password.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".checkout-otp-input-digit paste": function(el) {
				let $el = $(el),
					regexpForInteger = /^\d+$/,
					$otpInputs = $('.checkout-otp-input-digit'),
					currentPropertyValue = $el.val();

				$el.val('');

				$el.one('input.fromPaste', function() {
					let pastedValue = $el.val();

					if (regexpForInteger.test(pastedValue) && 6 === pastedValue.length) {
						$otpInputs.each(function(index) {
							$(this).val(pastedValue.charAt(index));
						});
					} else {
						$el.val(currentPropertyValue);
					}
					$otpInputs.attr('maxlength', 1);
				});

				$otpInputs.attr('maxlength', 6);
			},
			/**
			 * Event handler to close one-time-password.
			 * @returns {undefined}
			 */
			".close-passwordModal click": function() {
				$('.contact-info-form input').addClass('checked');
			},
			/**
			 * Event handler to submit the guest checkout form when loses focus.
			 * @param {Element} el The DOM element that triggered the event.
			 * @param {Object} e The event object.
			 * @returns {undefined}
			 */
			".contact-info-form input blur": function(el, e) {
				let $el = $(el);

				// If blur event is not occurred by clicking social login btn.
				if (clickedelement
					&& !clickedelement.hasClass('btn-social')
					&& !clickedelement.hasClass('google-pay-button')
					&& !clickedelement.hasClass('paypal-button-buy-now')
				) {
					if ($el.val()) {
						if (!$el.hasClass('checked')) {
							this.viewModel.submitGuestCheckout(el);
							this.viewModel.trackEvent('Checkout Method', 'Email - keyboard');
						}
					}
				}
			},
			/**
			 * Event handler to track the continue without logging in link.
			 * @returns {undefined}
			 */
			".continue-as-guest click": function() {
				this.viewModel.trackEvent('Checkout Method', 'Continue without logging in - click');
			},
			/**
			 * Event handler to track the continue without logging in link.
			 * @returns {undefined}
			 */
			".continue-without-shipping click": function() {
				let viewModel = this.viewModel,
					Order = viewModel.attr('Order');

				Order.attr('shipping_method', 'NOT');
				Order.attr('shipping_fee', '0');
				Order.attr('shippingMethodName', 'N/A');

				can.route.attr(
					'section',
					(viewModel.attr('hasAvailableCredit') ? 'availableCredit' : 'paymentMethod')
				);

				viewModel.trackEvent('Shipping Method', 'Shipping Method Not Available - click');
			},
			/**
			 * Event handler to open dropdown, shows all available credit cards in vault.
			 * @param {Element} el The DOM element that triggered the event.
			 * @param {Object} e The event object.
			 * @returns {undefined}
			 */
			".customer-vault-container .customer-vault-dropdown-btn click": function(el, e) {
				e.preventDefault();
				$(el).toggleClass('js-open')
					.parent().next('.customer-vault-body').toggleClass('js-open')
					.toggleClass('d-none');
			},
			/**
			 * Event handler to open shipping address pannel on "edit" button click.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".edit-available-credit click": function(el) {
				this.viewModel.clearErrors($(el).closest('.form'));
				can.route.attr('section', 'availableCredit');
			},
			/**
			 * Event handler to open the billing address pannel on "edit" button click.
			 * @returns {undefined}
			 */
			".edit-billing-address click": function() {
				if ('paymentMethod' !== this.viewModel.attr('Progress.section')) {
					can.route.attr('section', 'paymentMethod');
				}
				this.viewModel.attr('BillingAddress.same_info', '0');
				document.getElementById('BillingAddress_same_info').scrollIntoView();
			},
			/**
			 * Event handler to open the checkout options pannel on "edit" button click.
			 * @returns {undefined}
			 */
			".edit-checkout-options click": function() {
				can.route.attr('section', 'checkoutOptions');
			},
			/**
			 * Event handler to open the checkout options pannel on "edit" button click.
			 * @returns {undefined}
			 */
			".edit-email-address click": function() {
				this.viewModel.attr('Customer').attr('is_guest_customer', '1');
			},
			/**
			 * Event handler to open shipping address pannel on "edit" button click.
			 * @returns {undefined}
			 */
			".edit-shipping-address click": function() {
				if ('undefined' !== typeof GoogleApiInstance) {
					GoogleApiInstance.dispatch('autocomplete', [this.viewModel.attr('useAutocomplete')]);
				}
				$('#shipping-address-panel').css('display', 'block');
				can.route.attr('section', 'shippingAddress');
			},
			/**
			 * Event handler to open shipping address pannel on "edit" button click.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".edit-address click": function(el) {
				this.viewModel.updateShippingAddress();

				$('#changeAddressModal').modal('hide');

				if ('undefined' !== typeof GoogleApiInstance) {
					GoogleApiInstance.dispatch('autocomplete', [this.viewModel.attr('useAutocomplete')]);
				}
				can.route.attr('section', 'shippingAddress');
			},
			/**
			 * Event handler to open Edit credit-card-address modal on "edit" button click.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".edit-credit-card click": function(el) {
				let id = $(el).data('id'),
					viewModel = this.viewModel,
					CustomerVaultData = viewModel.attr('CustomerVault').attr(id),
					VaultAddress = viewModel.attr('VaultAddress');

				VaultAddress.attr('first_name', CustomerVaultData.attr('billing_first_name'));
				VaultAddress.attr('last_name', CustomerVaultData.attr('billing_last_name'));
				VaultAddress.attr('company', '');
				VaultAddress.attr('address_1', CustomerVaultData.attr('billing_street_address'));
				VaultAddress.attr('address_2', CustomerVaultData.attr('billing_extended_address'));
				VaultAddress.attr('city', CustomerVaultData.attr('billing_locality'));
				VaultAddress.attr('state', CustomerVaultData.attr('billing_region'));
				VaultAddress.attr('zip', CustomerVaultData.attr('billing_postal_code'));
				VaultAddress.attr('country', CustomerVaultData.attr('billing_country_code'));

				$('.card-update-modal-header').text('Edit address of card ending in ' + CustomerVaultData.attr('last4'));
				$('.update-vault-billing-address').data('token', id);
				$('#vaultBillingAddress').modal('show');
			},
			/**
			 * Event handler to open shipping method pannel on "edit" button click.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".edit-shipping-method click": function(el) {
				this.viewModel.clearErrors($(el).closest('.form'));
				can.route.attr('section', 'shippingMethod');
			},
			/**
			 * Event handler to open payment method pannel on "edit" button click.
			 * @returns {undefined}
			 */
			".edit-payment-method click": function() {
				if ('undefined' !== typeof GoogleApiInstance) {
					GoogleApiInstance.dispatch('autocomplete', [this.viewModel.attr('useAutocomplete')]);
				}
				can.route.attr('section', 'paymentMethod');
			},
			/**
			 * Event handler to open forgot password modal.
			 * @returns {undefined}
			 */
			".forgot-password click": function() {
				$('.passwordModal .forgot-password-container')
					.removeClass('no-display')
					.siblings().addClass('no-display');
			},
			/**
			 * Event handler to submit the checkout login form by enter key.
			 * @param {Element} el The DOM element that triggered the event.
			 * @param {Object} e The event object.
			 * @returns {undefined}
			 */
			".login-form input keyup": function(el, e) {
				if (this.viewModel.isEnterKeyEvent(e)) {
					this.viewModel.submitLogin(el);
					this.viewModel.trackEvent('Checkout Method', 'Login Submit - keyboard');
				}
			},
			/**
			 * Event handler to submit the checkout login form by button click.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			"#login-submit click": function(el) {
				this.viewModel.submitLogin(el);
				this.viewModel.trackEvent('Checkout Method', 'Login Submit - click');
			},
			/**
			 * Sets the order's shipping information when the shipping method selection changes.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".order-shipping-method-radio change": function(el) {
				let Order = this.viewModel.attr('Order'),
					$el = $(el);

				Order.attr('shipping_fee', $el.data('shippingFee'));
				Order.attr('shippingMethodName', $el.data('shippingName'));
			},
			/**
			 * Event handler to open shipping address panel.
			 * @returns {undefined}
			 */
			".otp-continue-as-guest click": function() {
				$('#passwordModal').modal('hide');
				this.viewModel.trackEvent('Checkout Method', 'OPT continue without login');
			},
			/**
			 * Event handler to send an one-time-password for easy checkout.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".otp-sign-in click": function(el) {
				this.viewModel.doAjaxRequest(
					el,
					'/checkout/express/request-otp',
					{
						email: this.viewModel.Customer.attr('email'),
						messageType: "email"
					},
					false
				);
				this.viewModel.trackEvent('Checkout Method', 'Ont-time-passcode - click');
			},
			/**
			 * Event handler to focus on Order_card_expiration_year.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			"#Order_card_expiration_month change": function(el) {
				if (2 === $(el).val().length && $('.mobileDevice').length) {
					$('#Order_card_expiration_year').focus();
				}
			},
			/**
			 * Event handler to focus on CheckoutForm_csc.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			"#Order_card_expiration_year change": function(el) {
				if (2 === $(el).val().length && $('.mobileDevice').length) {
					$('#CheckoutForm_csc').focus();
				}
			},
			/**
			 * Event handler to dim credit card icons of non-matching card companies on keyup event.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			" #Order_card_number keyup": function(el) {
				this.viewModel.handleCardInput(el);
			},
			/**
			 * Event handler to dim credit card icons of non-matching card companies on change event.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			" #Order_card_number change": function(el) {
				this.viewModel.handleCardInput(el);
			},
			/**
			 * Event handler to submit the payment method form by enter key.
			 * @param {Element} el The DOM element that triggered the event.
			 * @param {Object} e The event object.
			 * @returns {undefined}
			 */
			".payment-method-form input keyup": function(el, e) {
				if (this.viewModel.isEnterKeyEvent(e)) {
					this.viewModel.submitPaymentMethod(el);
					this.viewModel.trackEvent('Payment Method', 'Payment Method Submit - ' + this.viewModel.attr('Order.payment_method_selected') + ' - keyboard');
				}
			},
			/**
			 * Event handler to submit the payment method form on button click.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".payment-method-submit click": function(el) {
				this.viewModel.submitPaymentMethod(el);
				this.viewModel.trackEvent('Payment Method', 'Payment Method Submit - ' + this.viewModel.attr('Order.payment_method_selected') + ' - click');
			},
			/**
			 * Event handler to change the route when the payment method radio button tab is clicked.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".payment-tabs click": function(el) {
				let paymentMethodVal = $(el).data('name');

				// Update the route.
				can.route.attr({
					section: "paymentMethod",
					paymentOption: can.camelize(paymentMethodVal.replace('_', '-'))
				});
				this.viewModel.trackEvent('Payment Method', 'Payment Method Change - ' + paymentMethodVal + ' - tab');
			},
			/**
			 * Event handler to submit the PayPal order confirmation.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".paypal-confirm-submit click": function(el) {
				this.viewModel.submitPaypalOrder(el);
				this.viewModel.trackEvent('Payment Method', 'Confirm PayPal Order Submit - click');
			},
			/**
			 * Event handler to close dropdown, shows all available credit cards in vault.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".payment-method-container input[name='payment-method'] change": function(el) {
				let contClass = $(el).data('paymentRadio');

				$('.payment-body').hide().filter('.' + contClass).show();
			},
			/**
			 * Event Handler to send reset password instruction to entered email.
			 * @param {Element} el The DOM element that triggered the action.
			 * @returns {undefined}
			 */
			".reset-password click": function(el) {
				this.viewModel.doAjaxRequest(
					el,
					'/checkout/express/reset-password-email',
					{
						email: this.viewModel.Customer.attr('email')
					},
					false
				);
				$('.reset-password-step').removeClass('no-display')
					.siblings().addClass('no-display');
				this.viewModel.trackEvent('Checkout Method', 'Reset password - click');
			},
			/**
			 * Event handler to re-send a requested otp.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".resend-code click": function(el) {
				this.viewModel.doAjaxRequest(
					el,
					'/checkout/express/request-otp',
					{
						email: this.viewModel.Customer.attr('email'),
						resendCode: true
					},
					false
				);
				this.viewModel.trackEvent('Checkout Method', 'Ont-time-passcode - click');
			},
			/**
			 * Event handler to reset the password.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".reset-password-submit click": function(el) {
				this.viewModel.submitResetPassword(el);
				this.viewModel.trackEvent('Checkout Method', 'Reset-Password');
			},
			/**
			 * Event handler to handle change of billing address.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".billing-address-book .BillingAddress_address_book_address_id_radio change": function(el) {
				var value = $(el).val();
				let SelectedAddress = null,
					viewModel = this.viewModel,
					BillingAddress = viewModel.attr('BillingAddress');

				if (viewModel.attr('AddressBookEntries')) {
					SelectedAddress = viewModel.attr('AddressBookEntries').attr(value);
				}
				BillingAddress.attr('first_name', SelectedAddress ? SelectedAddress.attr('first_name') : '');
				BillingAddress.attr('last_name', SelectedAddress ? SelectedAddress.attr('last_name') : '');
				BillingAddress.attr('company', SelectedAddress ? SelectedAddress.attr('company') : '');
				BillingAddress.attr('address_1', SelectedAddress ? SelectedAddress.attr('address_1') : '');
				BillingAddress.attr('address_2', SelectedAddress ?  SelectedAddress.attr('address_2') : '');
				BillingAddress.attr('city', SelectedAddress ? SelectedAddress.attr('city') : '');
				BillingAddress.attr('state', SelectedAddress ?  SelectedAddress.attr('state') : '');
				BillingAddress.attr('zip', SelectedAddress ?  SelectedAddress.attr('zip') : '');
				BillingAddress.attr('country', SelectedAddress ?  SelectedAddress.attr('country') : '');
				BillingAddress.attr('phone', SelectedAddress ?  SelectedAddress.attr('phone_1') : '');
				BillingAddress.attr('address_book_address_id', SelectedAddress ? value : '0');

				let addressBook = el.closest('.address-book'),
					addressLabel = addressBook.find('span.address-placeholder').clone(),
					selectedAddressPlaceholder = $('.selected-address-placeholder');

				if (addressBook.hasClass('info')) {
					selectedAddressPlaceholder.html(addressLabel);
				}
			},
			/**
			 * Event handler to handle change of BillingAddress_same_info.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".billing-address #BillingAddress_same_info change": function(el) {
				if (this.viewModel.attr('CustomerVault') !== '') {
					let radio = $("input[name='customer-vault-radio']:checked"),
						vaultAddressPlaceholder = radio.closest('.card_radio').find('.vault-address-placeholder').clone(),
						selectedAddressPlaceholder = $('.selected-address-container .selected-address-placeholder');

					vaultAddressPlaceholder.removeClass('d-none');
					selectedAddressPlaceholder.html(vaultAddressPlaceholder);
				} else {
					if (this.viewModel.BillingAddress.same_info) {
						this.viewModel.updateBillingAddress();
					}
					let addressBook = $('.address-book.info'),
						addressLabel = addressBook.find('span.address-placeholder').clone(),
						selectedAddressPlaceholder = $('.selected-address-placeholder');

					selectedAddressPlaceholder.html(addressLabel);
				}
			},
			/**
			 * Event handler to handle change of shipping protection checkbox.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			'#CheckoutForm_shippingProtectionSelected change': function(el) {
				this.viewModel.submitShippingProtection(el);
			},
			/**
			 * Event handler to handle change of card selection from CustomerVault.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".paymentMethodWrapper .use-selected-vaulted-card click": function(el) {
				let radio = $("input[name='customer-vault-radio']:checked"),
					value = radio.val(),
					selectedVault = radio.attr('id'),
					cardPlaceholder = radio.closest('.card_radio').find('.card-placeholder').clone(),
					vaultCard = radio.closest('.vault-card'),
					selectedVaultCard = $('.selected-vault-card-container .vault-card'),
					vaultAddressPlaceholder = radio.closest('.card_radio').find('.vault-address-placeholder').clone(),
					selectedAddressPlaceholder = $('.selected-address-placeholder'),
					viewModel = this.viewModel;

				$('.customer-vault-title').text(value);
				viewModel.Order.attr('cardIdentifier', selectedVault);
				selectedVaultCard.html(cardPlaceholder);
				selectedAddressPlaceholder.html(vaultAddressPlaceholder);
				if (vaultCard.hasClass('default')) {
					selectedVaultCard.addClass('default');
					$('.selected-vault-card-container label:last').removeClass('d-none');
					selectedVaultCard.removeClass('p-2').addClass('px-2 pt-4 pb-2');
				} else {
					selectedVaultCard.removeClass('default');
					$('.selected-vault-card-container label:last').addClass('d-none');
					selectedVaultCard.addClass('p-2').removeClass('px-2 pt-4 pb-2');
				}
				$('.other-saved-card-container').toggleClass('d-none');
				$('.use-another-saved-card.top').addClass('d-none');
				$('.use-another-saved-card.bottom').removeClass('d-none');
				// Check if selected card needs re-verification for shipping address.
				this.viewModel.verifyCard(radio);
			},
			/**
			 * Event handler to return user to address-book
			 * @returns {undefined}
			 */
			".return-to-address-book click": function() {
				$('.billing-address-form').addClass('d-none');
				$('.return-to-address-book').addClass('d-none');
				$('.billing-address-book').removeClass('d-none');
			},
			/**
			 * Event handler to return user to vault
			 * @returns {undefined}
			 */
			".return-to-vault click": function() {
				// Before returning to vault clear billing address data.
				let radio = $("input[name='customer-vault-radio']:checked"),
					useNewCard = $('.use-new-card'),
					selectedVault = radio.attr('id');

				this.viewModel.Order.attr('cardIdentifier', selectedVault);
				this.viewModel.attr('BillingAddress.same_info', '1');
				$('.return-to-address-book').trigger('click');
				$('#save_to_account').prop('checked', false);
				// Hide all billing address elements and un-hide vault.
				$('.add-card-to-vault').addClass('d-none');
				$('.save-to-account').addClass('d-none');
				$('.billing-address').addClass('d-none');
				$('.return-to-address-book').addClass('d-none');
				$('.return-to-vault').addClass('d-none');
				$('.customer-vault-container').removeClass('d-none');
				$('.use-another-saved-card.plus').removeClass('d-none');
				if (this.viewModel.attr('defaultCardReVerificationNeeded')) {
					$('.card-holder-name-input').addClass('d-none');
				}
				useNewCard.removeClass('d-none');
				useNewCard.addClass('d-flex');
			},
			/**
			 * Event handler to fill city and state from zipcode.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			"#ShippingAddress_zip change": function(el) {
				this.viewModel.getCityState(el);
				this.viewModel.trackEvent('Checkout Method', 'Popup City and State');
			},
			/**
			 * Event handler to open input field for Apartment, building, floor in Shipping address form.
			 * @returns {undefined}
			 */
			".shipping-address-optional click": function() {
				$('.shipping-address-2').removeClass('d-none');
				$('.shipping-address-optional').addClass('d-none');
			},
			/**
			 * Event handler to submit the shipping address form on button click.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			"#shipping-address-submit click": function(el) {
				this.viewModel.submitShippingAddress(el);
				this.viewModel.trackEvent('Shipping Addres', 'Shipping Addres Submit - click');
			},
			/**
			 * Event handler to submit the shipping address form by enter key.
			 * @param {Element} el The DOM element that triggered the event.
			 * @param {Object} e The event object.
			 * @returns {undefined}
			 */
			".shipping-address-form input keyup": function(el, e) {
				if (this.viewModel.isEnterKeyEvent(e)) {
					let viewModel = this.viewModel;

					setTimeout(function() {
						viewModel.submitShippingAddress(el);
						viewModel.trackEvent('Shipping Addres', 'Shipping Addres Submit - keyboard');
					}, 500);
				}
			},
			/**
			 * Event handler to submit the shipping method form on button click.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			"#shipping-method-submit click": function(el) {
				this.viewModel.submitShippingMethod(el);
				this.viewModel.trackEvent('Shipping Method', 'Shipping Method Submit - click');
			},
			/**
			 * Event handler to select the shipping method radio button when the button's table row is clicked.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".shipping-method-table .shipping-method click": function(el) {
				$(el).addClass('success')
					.find('input.radio').prop('checked', true).trigger('change')
					.end().siblings().removeClass('success');
			},
			/**
			 * Event handler to update billing address associated with card in CustomerVault.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".update-billing-address click": function(el) {
				$(el).closest('.address_radio')
					.find('input')
					.prop('checked', true);
				$('.billing-address-book').addClass('d-none');
				$('.billing-address-form').removeClass('d-none');
			},
			/**
			 * Event handler to update shipping address form on "continue with this address" button click.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".update-shipping-address-form click": function(el) {
				this.viewModel.updateShippingAddress();

				$('#changeAddressModal').modal('hide');

				if ('shippingAddress' === this.viewModel.attr('Progress.section')) {
					$('#shipping-address-submit').click();
				} else {
					this.viewModel.submitShippingAddressUpdate(el);
				}
			},
			/**
			 * Event handler to open billing_address_form to use new address.
			 * @param {Element} el The DOM element that triggered the event.
			 * @returns {undefined}
			 */
			".use-new-billing-address click": function(el) {
				$('.billing-address-form').removeClass('d-none');
				$('.return-to-address-book').removeClass('d-none');
				$('.billing-address-book').addClass('d-none');
			},
			/**
			 * Event handler to open vault from card re-verification.
			 * @returns {undefined}
			 */
			".use-different-payment-method click": function() {
				$('.verify-card-details').addClass('d-none');
			},
			/**
			 * Event handler to open saved card list.
			 * @returns {undefined}
			 */
			".use-another-saved-card.bottom click": function(el) {
				$(el).addClass('d-none');
				$('.other-saved-card-container').removeClass('d-none');
				$('.use-another-saved-card.top').removeClass('d-none');
			},
			/**
			 * Event handler to open saved card list.
			 * @returns {undefined}
			 */
			".use-another-saved-card.top click": function(el) {
				$(el).addClass('d-none');
				$('.other-saved-card-container').addClass('d-none');
				$('.use-another-saved-card.bottom').removeClass('d-none');
			},
			/**
			 * Event handler to open card_details form to use new card.
			 * @returns {undefined}
			 */
			".use-new-card click": function(el) {
				this.viewModel.Order.attr('cardIdentifier', 'new-card');
				let $el = $(el);

				$el.addClass('d-none');
				$el.removeClass('d-flex');
				$('.card-holder-name-input').removeClass('d-none');
				$('.add-card-to-vault').removeClass('d-none');
				$('.save-to-account').removeClass('d-none');
				$('.billing-address').removeClass('d-none');
				$('.return-to-vault').removeClass('d-none');
				$('.customer-vault-container').addClass('d-none');
				$('.use-another-saved-card.plus').addClass('d-none');
			},
			/**
			 * Event handler to use new payment method from card re-verification
			 * @returns {undefined}
			 */
			".use-new-payment-method click": function() {
				$('.add-card-to-vault').removeClass('card-verification-error')
					.removeClass('card-mismatch-error');
				$('.use-new-card').trigger('click');
			},
			/**
			 * Event handler to open input field for Apartment, building, floor in Vault address.
			 * @returns {undefined}
			 */
			".VaultAddress-address-optional click": function() {
				$('.VaultAddress-address-2').removeClass('d-none');
				$('.VaultAddress-address-optional').addClass('d-none');
			},
			/**
			 * Event handler to close the modal with id "cvvDetail".
			 * @returns {undefined}
			 */
			".closeBtn click": function() {
				$("#cvvDetail").modal("hide");
			}
		}
	});

	// Render the component.
	$('#out').html(can.view('checkout-main'));

	$(document).ready(function() {
		let viewModel = $('checkout-main').viewModel();

		if (viewModel.attr('isOTPRequested') && viewModel.attr('isGuest')) {
			$('.passwordModal .otp-block-step').removeClass('no-display')
				.siblings().addClass('no-display');

			if (viewModel.attr('textMessagePhoneNumber')) {
				$('.otp-message').text('Enter the OTP code sent to your email address and phone number ending with (***)-***-' + viewModel.attr('textMessagePhoneNumber').substr(viewModel.attr('textMessagePhoneNumber').length - 4));
			}

			$('.passwordModal .container-password').removeClass('no-display');
			$('#passwordModal').modal('show');

			$('#email-logo').text((viewModel.Customer.attr('email').charAt(0)).toUpperCase());

			if (viewModel.Customer.attr('email').length > 18) {
				$('.modal-header p').text(viewModel.Customer.attr('email').slice(0, 18) + '...');
			} else {
				$('.modal-header p').text(viewModel.Customer.attr('email'));
			}
		}

		if ($('.vault-card-outer-container').length <= 1) {
			$('.use-another-saved-card').addClass('d-none');
		}

		// Move express checkout buttons to step 2 for non-guest users who skip step 1
		if (viewModel.attr('AddressBookEntries') && !viewModel.attr('isGuest') && !viewModel.attr('confirmPaypal')) {
			let $expressCheckout = $('.expressCheckoutContainer');
			if ($expressCheckout.length > 0) {
				$('#shipping-method').prepend($expressCheckout);
			}
		}

		if (window.ApplePaySession && ApplePaySession.canMakePayments()) {
			configApplePay();
			configGooglePay();
		} else {
			$('.btn-apple-pay-express-checkout').removeClass('d-flex').addClass('d-none');
			configGooglePay();
		}

		if ($('#paypal-button-buy-now').length > 0) {
			configPaypal();
		}

		if (viewModel.attr('confirmPaypal')) {
			$('.shippingMethodStep').addClass('active');
		} else if (viewModel.attr('AddressBookEntries') && !viewModel.attr('isGuest')) {
			viewModel.submitShippingAddressUpdate($('.update-shipping-address-form').get(0));
			$('.first-step .bi-check').css('display', 'block');
			if (!Progress.hasOwnProperty('section')) {
				$('.shippingMethodStep').addClass('active');
			}
		} else if (Progress.hasOwnProperty('section')) {
			let sectionName = Progress.section + 'Step';

			$('.' + sectionName).addClass('active').siblings().removeClass('active');
		} else {
			$('.shippingAddressStep').addClass('active');
		}


		function setItemSummaryMaxHeight() {
			let $viewPortHeight = $(window).outerHeight(),
				$headerNavWrapper = $('.header-nav-wrapper').outerHeight(),
				$orderSummaryBottomSection = $('.orderSummaryBottomSection').outerHeight(),
				$orderItemSummarySection = $viewPortHeight - $headerNavWrapper - $orderSummaryBottomSection - 7;

			$('.orderItemSummarySection').css('max-height', $orderItemSummarySection + 'px');
		}

		// Function to move the div
		function moveDiv() {
			let windowWidth = $(window).outerWidth();

			if (windowWidth < 992) {
				$('.cart-menu').appendTo('.orderSummaryBody');
				$('.orderItemSummarySection').css('max-height', '');
			} else {
				$('.cart-menu').appendTo('.checkout-page');
				setItemSummaryMaxHeight();
			}
		}

		// Initial move
		moveDiv();

		// Move on resize
		$(window).resize(function() {
			moveDiv();
		});

		// Set default credit card as a selected payment-method
		$('.customer-vault-title').text($(".customer-vault-body input[name='customer-vault-radio']:checked").val());

		if ($('.customer-vault-container').length > 0) {
			let radio = $("input[name='customer-vault-radio']:checked"),
				cardPlaceholder = radio.closest('.card_radio').find('.card-placeholder').clone(),
				vaultCard = radio.closest('.vault-card'),
				selectedVaultCard = $('.selected-vault-card-container .vault-card');

			selectedVaultCard.html(cardPlaceholder);
			if (vaultCard.hasClass('default')) {
				selectedVaultCard.addClass('default');
				$('.selected-vault-card-container label:last').removeClass('d-none');
				selectedVaultCard.removeClass('p-2').addClass('px-2 pt-4 pb-2');
			} else {
				selectedVaultCard.removeClass('default');
				$('.selected-vault-card-container label:last').addClass('d-none');
				selectedVaultCard.addClass('p-2').removeClass('px-2 pt-4 pb-2');
			}
		}
	});

	$(document.body).click(function(e) {
		if ($(e.target).hasClass('checkout-page')) {
			// Closes card update options when user clicks outside.
			$('.card-update-container').addClass('d-none')
				.removeClass('active');
		}
	});
}

/**
 * Navigation bar event Handler
 */
$('#grey-overlay').click(function() {
	$(this).removeClass('active active-body-cover');
	$('.cart-menu').animate({right:  '-30rem'}, 500);
	$(document.body).removeClass('body-opa');
});

// Get recently clicked element.
$(document.body).mousedown(function(e) {
	clickedelement = $(e.target);
});
/**
 * This is a function for updating cart_menu_total.
 * @param {String} total
 */
function setCartTotal(total) {
	if ($('.cart-total').length > 0) {
		let $cartMenuTotal = $('#cart-menu-total');

		if ($cartMenuTotal.text() != ('$' + total)) {
			$cartMenuTotal.text('$' + total);
		}
	}
}

/**
 * This is a global function for logging errors.
 * @param {String} errorMessage
 */
function logError(errorMessage) {
	let errorMsg = errorMessage.toString();

	errorMsg += '\nurl: ' + window.location.href;
	errorMsg += ('undefined' === typeof errorMessage.stack ? '' : ('\nstack: ' + errorMessage.stack));

	if (window.hasOwnProperty('navigator')) {
		if ('undefined' !== typeof window.navigator.userAgent) {
			errorMsg += '\nuser agent: ' + window.navigator.userAgent;
		}
	}

	let formData = new FormData();

	formData.append('error', errorMsg);
	fetch('/javascript/error', {
		method: 'POST',
		body: formData
	});
}

/**
 * This is a global function Google map for authentication errors.
 * If the following global function is defined it will be called when the authentication fails.
 */
window.gm_authFailure = function() {
	// remove auto complete input disabled in case of authentication failure
	let shippingAddressAddress1 = document.getElementById('ShippingAddress_address_1'),
		orderAddressAddress1 = document.getElementById('OrderAddress_address_1');

	shippingAddressAddress1.disabled = false;
	orderAddressAddress1.disabled = false;
	shippingAddressAddress1.removeAttribute('style');
	orderAddressAddress1.removeAttribute('style');

	return false;
}

if ('undefined' !== typeof google) {
	/**
	 * Programmatic Google Places Autocomplete for multiple inputs.
	 *
	 * Keeps existing inputs with class `.autocomplete` and renders a lightweight, accessible
	 * dropdown beneath each field. On selection, hydrates a Place and fills a CanJS
	 * address view-model (Shipping/Billing/Vault) based on which input fired.
	 *
	 * Prerequisites:
	 *  - Google Maps JS loaded with `v=weekly` and `libraries=places`
	 *
	 * Side effects:
	 *  - Appends a dropdown element (`.address-predictions-dd`) next to each input
	 *  - Binds `input`, `focus`, `blur`, and `keydown` DOM listeners
	 *  - Uses an `AutocompleteSessionToken` to group predictions + selection for billing
	 *
	 * Accessibility:
	 *  - Options use `role="option"`, keyboard nav via ↑/↓/Enter/Esc
	 *
	 * @constructor GoogleApiClass
	 * @memberof responsiveCustomer.address
	 * @requires google.maps.importLibrary('places')
	 * @requires google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions
	 * @requires google.maps.places.AutocompleteSessionToken
	 * @requires google.maps.places.Place#fetchFields
	 */
	var GoogleApiClass = can.Construct('GoogleApiClass', {
		/**
		 * Initializes the instance and attaches autocomplete behavior to all
		 * `.autocomplete` inputs on the page.
		 *
		 * @this GoogleApiClass
		 * @returns {void}
		 */
		init: function() {
			/**
			 * @private @type {Array<Function>} Cleanup callbacks per input.
			 */
			this._cleanups = [];
			this.attachAutocompleteBehavior();
		},
		/**
		 * Attaches programmatic Place Autocomplete to every input with class
		 * `.autocomplete`. For each input, a per-input cleanup function is stored.
		 *
		 * @this GoogleApiClass
		 * @returns {void}
		 */
		attachAutocompleteBehavior: function() {
			if (typeof google !== 'undefined') {
				const inputs = document.getElementsByClassName('autocomplete');

				for (let i = 0; i < inputs.length; i++) {
					this._cleanups.push(this._setupForInput(inputs[i]));
				}
			}
		},
		/**
		 * Detaches all bound listeners and removes all in-DOM dropdowns that were
		 * created by this instance. Also removes legacy `.pac-container` nodes if present.
		 *
		 * Safe to call multiple times.
		 *
		 * @this GoogleApiClass
		 * @returns {void}
		 */
		detachAutocompleteBehavior: function() {
			if (typeof google !== 'undefined') {
				(this._cleanups || []).forEach(fn => {
					try {
						fn && fn();
					} catch (_) {
					}
				});
				this._cleanups = [];
				// Legacy cleanup (no-op in new flow)
				document.querySelectorAll('.pac-container').forEach(el => el.remove());
			}
		},
		/**
		 * Wires up a single input element with programmatic Place Autocomplete:
		 * - Renders and positions a dropdown under the input (without re-parenting)
		 * - Debounced fetch of predictions via `AutocompleteSuggestion.fetchAutocompleteSuggestions`
		 * - On selection, creates a `Place`, fetches `addressComponents`, and updates the
		 *   appropriate CanJS address view-model (Shipping/Billing/Vault).
		 *
		 * Returns a cleanup function that removes listeners and the dropdown for this input.
		 *
		 * @private
		 * @this GoogleApiClass
		 * @param {HTMLInputElement} inputEl The input to enhance.
		 * @returns {Function} Cleanup function for this input (no-arg, idempotent).
		 */
		_setupForInput: function(inputEl) {
			if (!inputEl) {
				return function() {};
			}

			// --- dropdown under the input (don’t re-parent the input) ---
			const parent = inputEl.parentElement;

			if (getComputedStyle(parent).position === 'static') {
				parent.style.position = 'relative';
			}

			const dd = document.createElement('div');

			dd.className = 'address-predictions-dd';
			Object.assign(dd.style, {
				position: 'absolute',
				zIndex: 9999,
				display: 'none',
				background: '#fff',
				border: '1px solid #ccc',
				borderTop: 'none',
				maxHeight: '260px',
				overflowY: 'auto'
			});
			parent.appendChild(dd);

			// --- positioning helpers ---
			const positionDD = () => {
				const r = inputEl.getBoundingClientRect();
				const rp = parent.getBoundingClientRect();

				if (r.width === 0 || r.height === 0) {
					// wait until visible
					return;
				}
				dd.style.left = (r.left - rp.left) + 'px';
				dd.style.top = (r.bottom - rp.top) + 'px';
				dd.style.minWidth = r.width + 'px';
			};
			const rafPosition = () =>
				requestAnimationFrame(() => {
					positionDD();
					requestAnimationFrame(positionDD);
				});

			// Keep position in sync with layout changes
			const ro = new ResizeObserver(rafPosition);

			ro.observe(inputEl);
			window.addEventListener('resize', rafPosition);
			window.addEventListener('scroll', rafPosition, true);

			// --- state ---
			let activeIdx = -1;
			let items = [];
			let sessionToken = null;
			let lastQuery = '';
			let typingTimer;
			let suppressEscapeHide = false;

			// --- helpers ---
			const showDD = () => {
				dd.style.display = (items.length ? 'block' : 'none');
				if (items.length) {
					rafPosition();
				}
			};
			const hideDD = () => {
				dd.style.display = 'none';
				activeIdx = -1;
			};
			const clearDD = () => {
				dd.innerHTML = '';
				items = [];
				activeIdx = -1;
			};

			const highlight = (i) => {
				if (activeIdx >= 0 && items[activeIdx]) {
					items[activeIdx].style.background = '';
				}
				activeIdx = i;
				if (items[activeIdx]) {
					items[activeIdx].style.background = '#f5f5f5';
				}
			};

			const renderItems = (suggestions) => {
				if (inputEl.value.trim() !== lastQuery) {
					// stale, drop it
					return;
				}
				clearDD();
				suggestions.forEach((sug, i) => {
					const li = document.createElement('div');

					li.setAttribute('role', 'option');
					li.style.padding = '8px 10px';
					li.style.cursor = 'pointer';
					li.style.borderTop = '1px solid #eee';
					li.textContent = sug.placePrediction.text.toString();
					li.addEventListener('mouseenter', () => highlight(i));
					// keep focus on input for click
					li.addEventListener('mousedown', (e) => e.preventDefault());
					li.addEventListener('click', () => choose(sug));
					dd.appendChild(li);
					items.push(li);
				});

				// Dispatch a synthetic Escape keydown to dismiss 1Password's auto-opened
				// dropdown when Google Places results appear. The suppressEscapeHide flag
				// prevents our own onKeydown handler from closing our dropdown in response.
				suppressEscapeHide = true;
				inputEl.dispatchEvent(new KeyboardEvent('keydown', {
					key: 'Escape',
					keyCode: 27,
					bubbles: true,
					cancelable: true
				}));
				suppressEscapeHide = false;

				showDD();
			};

			/**
			 * Handles selection: converts a prediction to a Place, fetches fields,
			 * and updates the appropriate CanJS address view-model.
			 *
			 * @param {{placePrediction: {toPlace: function(): google.maps.places.Place, text: {toString: function(): string}}}} suggestion
			 * @returns {Promise<void>}
			 */
			const choose = async (suggestion) => {
				hideDD();
				try {
					const place = suggestion.placePrediction.toPlace();

					await place.fetchFields({
						// Avoid paying for data that we don't need by restricting the set of
						// place fields that are returned to just the address components.
						fields: ['addressComponents'],
						// Uses same session token as the predictions request
						sessionToken
					});

					// Resolve which VM to update based on input id
					const vm = $('checkout-main').viewModel();
					let addressToUpdate = vm.attr('ShippingAddress');

					if (inputEl.id === 'OrderAddress_address_1' || inputEl.id === 'BillingAddress_address_1') {
						addressToUpdate = vm.attr('BillingAddress');
					} else if (inputEl.id === 'VaultAddress_address_1') {
						addressToUpdate = vm.attr('VaultAddress');
					}

					// Reset fields
					addressToUpdate.attr({address_1: '', address_2: '', city: '', state: '', country: '', zip: ''});

					// Extract fields (new API uses longText/shortText)
					let country = '',
						line1 = '',
						postcode = '',
						state = '';

					for (const c of (place.addressComponents || [])) {
						const type = c.types && c.types[0];
						const long = c.longText;
						const short = c.shortText || long;

						switch (type) {
							case 'street_number':
								line1 = `${long}` + (line1 ? ` ${line1}` : '');

								break;

							case 'route':
								line1 += (line1 ? ' ' : '') + short;

								break;

							case 'locality':
								addressToUpdate.attr('city', long);

								break;

							case 'administrative_area_level_1':
								state = short;

								break;

							case 'country':
								country = short;

								break;

							case 'postal_code':
								postcode = short;

								break;

							case 'postal_code_suffix':
								if (postcode) {
									postcode = `${postcode}-${short}`;
								}

								break;
						}
					}

					// Fallback: if the API did not return a street_number component,
					// extract it from the formatted prediction text (e.g. "2910 Marlboro Circle, ...").
					if (line1 && !/^\d/.test(line1)) {
						let predictionText = suggestion && suggestion.placePrediction && suggestion.placePrediction.text;

						if (predictionText) {
							let numMatch = predictionText.toString().match(/^(\d+[\w-]*)\s/);

							if (numMatch) {
								line1 = numMatch[1] + ' ' + line1;
							}
						}
					}

					addressToUpdate.attr('address_1', line1);
					addressToUpdate.attr('country', country);

					if ('CA' == country && 'QC' == state) {
						addressToUpdate.attr('state', 'PQ');
					} else {
						addressToUpdate.attr('state', state);
					}
					addressToUpdate.attr('zip', postcode);
				} catch (e) {
					// Fallback: just show selected text
					inputEl.value = suggestion.placePrediction.text.toString();
				} finally {
					// End session after a selection
					sessionToken = null;
					// keep the cache in sync with what the user now sees
					lastQuery = inputEl.value;
				}
			};

			// --- input typing -> fetch suggestions (debounced) ---
			const onInput = () => {
				clearTimeout(typingTimer);
				typingTimer = setTimeout(async () => {
					const q = inputEl.value.trim();

					if (!q || q === lastQuery) {
						clearDD();
						hideDD();
						lastQuery = q;

						return;
					}
					lastQuery = q;

					try {
						if (google?.maps?.importLibrary) {
							await google.maps.importLibrary('places');
						}

						if (!sessionToken) {
							const {AutocompleteSessionToken} = await google.maps.importLibrary('places');

							sessionToken = new AutocompleteSessionToken();
						}
						const {AutocompleteSuggestion} = await google.maps.importLibrary('places');

						/**
						 * @type {{input: string, sessionToken: object, includedRegionCodes?: string[], locationBias?: object}}
						 */
						const req = {
							input: q,
							// Optional scoping:
							// includedRegionCodes: ['US'],
							// locationBias: {...},
							sessionToken
						};

						const {suggestions} = await AutocompleteSuggestion.fetchAutocompleteSuggestions(req);

						renderItems(suggestions || []);
					} catch (_) {
						clearDD();
						// silent fail keeps typing UX smooth
						hideDD();
					}
				}, 120);
			};

			// --- focus/blur/keys ---
			const onFocus = () => {
				if (items.length) {
					dd.style.display = 'block';
					rafPosition();
				}
			};
			const onBlur = () => setTimeout(hideDD, 150);
			const onKeydown = (e) => {
				if (dd.style.display === 'none') {
					return;
				}
				if (e.key === 'ArrowDown') {
					e.preventDefault();
					highlight((activeIdx + 1) % items.length);
				} else if (e.key === 'ArrowUp') {
					e.preventDefault();
					highlight((activeIdx - 1 + items.length) % items.length);
				} else if (e.key === 'Enter') {
					if (activeIdx >= 0 && items[activeIdx]) {
						e.preventDefault();
						items[activeIdx].click();
					}
				} else if (e.key === 'Escape') {
					if (!suppressEscapeHide) {
						hideDD();
					}
				}
			};

			// --- bind ---
			inputEl.addEventListener('input', onInput);
			inputEl.addEventListener('focus', onFocus);
			inputEl.addEventListener('blur', onBlur);
			inputEl.addEventListener('keydown', onKeydown);

			/**
			 * Cleanup function for this input: unbind listeners, remove dropdown,
			 * and stop observing window events used for positioning.
			 *
			 * @returns {void}
			 */
			return function cleanup() {
				clearTimeout(typingTimer);
				inputEl.removeEventListener('input', onInput);
				inputEl.removeEventListener('focus', onFocus);
				inputEl.removeEventListener('blur', onBlur);
				inputEl.removeEventListener('keydown', onKeydown);
				window.removeEventListener('resize', rafPosition);
				window.removeEventListener('scroll', rafPosition, true);
				ro.disconnect();
				dd.remove();
			};
		}
	});

	/**
	 * Adds event functionality to GoogleApiClass prototype.
	 * With can.event mixed in, instances can add/remove/dispatch events.
	 */
	can.extend(GoogleApiClass.prototype, can.event);

	/**
	 * Google Pay constructor function.
	 * @function GooglePayClass
	 */
	var GooglePayClass = can.Construct('GooglePayClass', {
		/**
		 * Initializes the instance.
		 * @returns {undefined}
		 */
		init: function() {
			this.loadGooglePay();
		},
		loadGooglePay: function() {
			try {
				if ('undefined' !== typeof braintree && 'undefined' !== typeof google && 'undefined' !== typeof google.payments) {
					let paymentsClient = new google.payments.api.PaymentsClient({
						environment: isProduction ? 'PRODUCTION' : 'TEST'
					});

					braintree.client.create({
						authorization: brainTreeAuthorizationToken
					}, function (clientErr, clientInstance) {
						braintree.googlePayment.create({
							client: clientInstance,
							googlePayVersion: 2,
							googleMerchantId: googleMerchantId
						}, function (googlePaymentErr, googlePaymentInstance) {
							let paymentDataRequestTemp = 'undefined' !== typeof googlePaymentInstance ? googlePaymentInstance.createPaymentDataRequest() : null,
								allowedPaymentMethodsTemp;

							if (paymentDataRequestTemp) {
								allowedPaymentMethodsTemp = paymentDataRequestTemp.allowedPaymentMethods;
							} else {
								allowedPaymentMethodsTemp = [{
									"type": "CARD",
									"parameters": {
										"allowedAuthMethods": ["PAN_ONLY", "CRYPTOGRAM_3DS"],
										"allowedCardNetworks": ["AMEX", "DISCOVER", "JCB", "MASTERCARD", "VISA"]
									}
								}];
							}

							paymentsClient.isReadyToPay({
								apiVersion: 2,
								apiVersionMinor: 0,
								allowedPaymentMethods: allowedPaymentMethodsTemp,
								existingPaymentMethodRequired: true
							}).then(function(response) {
								if (response.result) {
									// add google pay button
									let viewModel = $('checkout-main').viewModel();

									const googlePayContainer = document.getElementById('google-pay-button-checkout');
									const gButton = paymentsClient.createButton({
										buttonColor: "default",
										buttonType: "buy",
										buttonSizeMode: "fill",
										onClick: () => {
											viewModel.trackEvent('Summary', 'Checkout Last Step button: Google Pay');
										}
									});

									googlePayContainer.appendChild(gButton);
									$('.btn-google-pay').removeClass('d-none').addClass('d-flex');

									// add event listener to google-pay button
									googlePayContainer.addEventListener('click', function(event) {
										event.preventDefault();
										let paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
												transactionInfo: {
													currencyCode: "USD",
													totalPriceStatus: "FINAL",
													totalPrice: viewModel.calculatedTotal().toString()
												}
											}),
											cardPaymentMethod = paymentDataRequest.allowedPaymentMethods[0];

										cardPaymentMethod.parameters.billingAddressRequired = true;
										cardPaymentMethod.parameters.billingAddressParameters = {
											format: "FULL",
											phoneNumberRequired: true
										};

										paymentsClient.loadPaymentData(paymentDataRequest).then(function(paymentData) {
											googlePaymentInstance.parseResponse(paymentData, function(err, result) {
												if (err) {
													logError(err.statusMessage);
												}

												let element = $('#google-pay-button-checkout').get(0),
													Order = {
														payment_method_selected: viewModel.Order.attr('payment_method_selected'),
														cardNumber: viewModel.Order.attr('card_number'),
														cardExpirationMonth: viewModel.Order.attr('card_expiration_month'),
														cardExpirationYear: viewModel.Order.attr('card_expiration_year'),
														shipping_method: viewModel.Order.attr('shipping_method')
													};

												viewModel.attr('BillingAddress.same_info', '0');
												viewModel.setBillingAddress(paymentData.paymentMethodData.info.billingAddress);
												viewModel.Order.attr('payment_method_selected', 'googlepay_bt');

												viewModel.doAjaxRequest(
													element,
													'/checkout/express/payment-method',
													{
														Order: Order,
														BillingAddress: viewModel.BillingAddress.serialize(),
														CheckoutForm: viewModel.CheckoutForm.serialize(),
														device_data: $('#device_data').val(),
														nonce: result.nonce
													},
													false
												);
											});
										}).catch(function(err) {
											logError(err);
										});
									});
								}
							}).catch(function(err) {
								logError(err);
							});
						});
					});
				}
			} catch(err) {
				logError(err);
			}
		}
	});

	/**
	 * Adds event functionality to GooglePayClass prototype.
	 * Now can.event is included in the prototype, we can add/remove/dispatch events on the object instances.
	 */
	can.extend(GooglePayClass.prototype, can.event);

	/**
	 * Instance of GoogleApiClass used to make autocomplete.
	 * @type GoogleApiClass
	 */
	var GoogleApiInstance = new GoogleApiClass();
	try {
		/**
		 * Event handler to switch autocomplete mode
		 */
		GoogleApiInstance.on('autocomplete', function(ev, enable) {
			if (enable) {
				this.detachAutocompleteBehavior();
				this.attachAutocompleteBehavior();
			} else {
				this.detachAutocompleteBehavior();
			}
		});
	} catch (e) {
		logError(e);
	}
}

// Set up the routes.
can.route('checkout/express');
can.route('checkout/express/:section', {section: "home"});
can.route('checkout/express/:section/:paymentOption');
can.route.map(Progress);
can.route.ready();
